import { GeneratedQuery } from "@aws-amplify/api-graphql";
import {
  AppointmentNotificationsByRecipientAndStatusQuery,
  AppointmentNotificationsByRecipientAndStatusQueryVariables,
  AppointmentRecordsByDoctorIDAndDateAndTimeQuery,
  AppointmentRecordsByDoctorIDAndDateAndTimeQueryVariables,
  AppointmentRecordsByLocationIDAndDateAndTimeQuery,
  AppointmentRecordsByLocationIDAndDateAndTimeQueryVariables,
  AppointmentRecordsByOriginalAppointmentIDQuery,
  AppointmentRecordsByOriginalAppointmentIDQueryVariables,
  AppointmentRecordsByUploadedFilesSetIDQuery,
  AppointmentRecordsByUploadedFilesSetIDQueryVariables,
  AppointmentStatus,
  AppointmentsByGlobalDateTimeQuery,
  AppointmentsByGlobalDateTimeQueryVariables,
  AppointmentsByGlobalInquiryDateQuery,
  AppointmentsByGlobalInquiryDateQueryVariables,
  AppointmentType,
  AudioByUploadedFileIDQueryVariables,
  BatchGetDataFieldsQuery,
  BatchGetDataFieldsQueryVariables,
  BillingStatus,
  BodyPartDiagnosis,
  CaseState,
  ChatbotMessageRole,
  ChatbotMessagesByConversationIdQueryVariables,
  CoverLetterRecapsByUploadedFileIDQuery,
  CoverLetterRecapsByUploadedFileIDQueryVariables,
  DataFieldsByCategoryQuery,
  DataFieldsByCategoryQueryVariables,
  DiagnosticStudy,
  DiscreteTreatment,
  DoctorLocationsByDoctorIdQuery,
  DoctorLocationsByDoctorIdQueryVariables,
  DocumentPagesByDocumentIDAndPageNumberQuery,
  DocumentPagesByDocumentIDAndPageNumberQueryVariables,
  DocumentsByUploadedFileIDQueryVariables,
  FieldTemplatesByDoctorIdAndVersionQuery,
  FieldTemplatesByDoctorIdAndVersionQueryVariables,
  GetAppointmentRecordQuery,
  GetAppointmentRecordQueryVariables,
  GetCaseRecordQueryVariables,
  GetDoctorQuery,
  GetDoctorQueryVariables,
  GetFieldTemplateQuery,
  GetFieldTemplateQueryVariables,
  GetInsuranceCarrierQuery,
  GetInsuranceCarrierQueryVariables,
  GetLawFirmQuery,
  GetLawFirmQueryVariables,
  GetMedicalAssistantQuery,
  GetMedicalAssistantQueryVariables,
  GetOpsGlobalSettingsQuery,
  GetOpsGlobalSettingsQueryVariables,
  GetReviewOfMedicalRecordsInsightsQueryVariables,
  GetUploadedFileQuery,
  GetUploadedFileQueryVariables,
  HistoryValidationsByAppointmentRecordIDQuery,
  HistoryValidationsByAppointmentRecordIDQueryVariables,
  IntroParagraphsByAppointmentRecordIDQuery,
  IntroParagraphsByAppointmentRecordIDQueryVariables,
  Language,
  LawFirmsByTypeQuery,
  LawFirmsByTypeQueryVariables,
  ListAppointmentsOptimizedQuery,
  ListAppointmentsOptimizedQueryVariables,
  ListAuditLogsQuery,
  ListAuditLogsQueryVariables,
  ListCaseRecordsQueryVariables,
  ListDataFieldSectionsQuery,
  ListDataFieldSectionsQueryVariables,
  ListDoctorsQuery,
  ListDoctorsQueryVariables,
  ListInsuranceCarriersQuery,
  ListInsuranceCarriersQueryVariables,
  ListLawFirmsQuery,
  ListLawFirmsQueryVariables,
  ListLocationsQuery,
  ListLocationsQueryVariables,
  ListMedicalAssistantsQuery,
  ListMedicalAssistantsQueryVariables,
  ListOnsiteOpsConfigsQuery,
  ListOnsiteOpsConfigsQueryVariables,
  ListRecordBriefingSegmentAnnotationsQuery,
  ListRecordBriefingSegmentAnnotationsQueryVariables,
  ListSpecialtyCategoriesQuery,
  ListSpecialtyCategoriesQueryVariables,
  ListStoredAddressesQuery,
  ListStoredAddressesQueryVariables,
  ListStoredFaxNumbersQuery,
  ListStoredFaxNumbersQueryVariables,
  ListStoredPhoneNumbersQuery,
  ListStoredPhoneNumbersQueryVariables,
  ListUserAppointmentFilterPresetsQuery,
  ListUserAppointmentFilterPresetsQueryVariables,
  ListUsersQueryVariables,
  NoShowReason,
  OfflineEvalCasesByPromptIdAndApiHashQueryVariables,
  ParticipantType,
  PhysicalEvalTemplate,
  PhysicalEvalTemplatesByDoctorIdAndVersionQueryVariables,
  PhysicalExamSide,
  PreviousReport,
  PromptExecutionsByPromptIdQueryVariables,
  RecordBriefing,
  RecurringTreatment,
  ReportStatus,
  SearchAppointmentsCustomQuery,
  SearchAppointmentsCustomQueryVariables,
  SegmentMappingsByBriefingIdQuery,
  SegmentMappingsByBriefingIdQueryVariables,
  SuggestionsByBriefingIdQuery,
  SuggestionsByBriefingIdQueryVariables,
  UsersByCognitoUserIdQuery,
  UsersByCognitoUserIdQueryVariables,
  WorkflowAuditEntriesByWorkflowAuditIDQuery,
  WorkflowAuditEntriesByWorkflowAuditIDQueryVariables,
  WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQuery,
  WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQueryVariables,
} from "~/api/API";

export const usersByCognitoUserId = /* GraphQL */ `query UsersByCognitoUserId(
  $cognitoUserId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByCognitoUserId(
    cognitoUserId: $cognitoUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        title
        titleExtension
        contact {
          phone
          phoneExtension
          email
          address {
            street
            city
            state
            zip
            __typename
          }
          fax
          homePhoneNumber
          __typename
        }
        officePhone
        cellPhone
        clinicPhone
        workCity
        workState
        collectionRate
        licenseNumber
        licenseRenewalDate
        qmeLicense {
          licenseNumber
          approvalDate
          renewalDate
          __typename
        }
        specialties
        npi
        assessmentTreatmentOptions
        preferredAssessmentMode
        bankingInfo {
          bankEntityName
          accountNumber
          routingNumber
          __typename
        }
        availabilities {
          generalAvailabilities {
            during {
              start
              end
              __typename
            }
            recurrence
            dayOfWeek
            dayOfMonth
            weekOfMonth
            monthInterval
            startTime
            endTime
            flexibleTimeBefore {
              startTime
              endTime
              __typename
            }
            flexibleTimeAfter {
              startTime
              endTime
              __typename
            }
            locationIDs
            isAllLocations
            __typename
          }
          additionalAvailabilities {
            during {
              start
              end
              __typename
            }
            startTime
            endTime
            flexibleTimeBefore {
              startTime
              endTime
              __typename
            }
            flexibleTimeAfter {
              startTime
              endTime
              __typename
            }
            locationIDs
            isAllLocations
            __typename
          }
          blackoutDates {
            during {
              start
              end
              __typename
            }
            startTime
            endTime
            allDay
            __typename
          }
          __typename
        }
        locations {
          items {
            id
            doctorId
            locationId
            location {
              id
              name
              address {
                street
                city
                state
                zip
                __typename
              }
              parkingRate
              isFrontDoorLocked
              doctors {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        emails
        profileImages {
          type
          name
          order
          s3Prefix
          widthInInches
          heightInInches
          __typename
        }
        qmeReportConfigs {
          hasIntroTitle
          introTemplate
          __typename
        }
        physicalEvalConfigs {
          templates
          __typename
        }
        signatureDepartment
        profileAssetS3Prefix
        calendarPreference {
          mailingList
          showPatientFullName
          showPatientAddress
          showPatientDOB
          showPortalLink
          __typename
        }
        homeOffice {
          county
          state
          __typename
        }
        dismissedProTips
        isDemo
        createdAt
        updatedAt
        doctorPhysicianPartnerId
        physicianPartner {
          id
          name
          email
          inactive
          __typename
        }
        doctorUserId
        __typename
      }
      assistant {
        id
        name
        email
        preVisitCallScheduleLink
        enableCalendarNotify
        inactive
        dismissedProTips
        isDemo
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      appointmentFilterPreset {
        items {
          id
          userId
          appointmentFilterPresetId
          appointmentFilterPreset {
            id
            name
            filters {
              type
              values
              __typename
            }
            appliesTo
            view
            users {
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  UsersByCognitoUserIdQueryVariables,
  UsersByCognitoUserIdQuery
>;

export const appointmentsByGlobalInquiryDate =
  /* GraphQL */ `query AppointmentsByGlobalInquiryDate(
  $globalPartitionKey: String!
  $inquiryDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalInquiryDate(
    globalPartitionKey: $globalPartitionKey
    inquiryDate: $inquiryDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      time
      additionalTimeslots {
        date
        time
        locationID
      }
      inquiryDate
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        title
        titleExtension
        contact {
          phone
          email
          fax
          homePhoneNumber
        }
        officePhone
        cellPhone
        clinicPhone
        collectionRate
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
      }
      locationID
      location {
        id
        name
        parkingRate
        isFrontDoorLocked
        address {
          street
          city
          state
          zip
        }
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      billingStatus
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingDate
      reschedulingNote
      panelUnavailable
      panelSpecialty
      videoCallLink
      isProd
      primaryPatientCaseID
      reportConfiguration {
        history
        physicalExamination
        assessment
      }
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          __typename
        }
        inquiringParty
        name
        notification_110_required
        __typename
      }
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        level
        preVisitCallScheduleLink
        inactive
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        level
        preVisitCallScheduleLink
        inactive
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        inactive
        __typename
      }
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      historyOfInjuryNotes {
        id
        content
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallCalendarLink
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        paidDate
        billedDate
        correctionDate
        billingCounter
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      patientCases {
        items {
          id
          patientCase {
            id
            patientID
            claimNumber
            injuryInfo {
              injuredBodyParts
              claimedBodyParts
              __typename
            }
            patient {
              id
              name
              dateOfBirth
              language
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                __typename
              }
            }
            workersCompInsurance {
              insuranceCarrier
              adjuster
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            qmePanelNumber
            applicantAttorney {
              name
              lawFirmName
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            defenseAttorney {
              name
              lawFirmName
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            applicantAttorneyLawFirmID
            applicantAttorneyLawFirm {
              id
              name
              __typename
            }
            defenseAttorneyLawFirmID
            defenseAttorneyLawFirm {
              id
              name
              __typename
            }
            injuryInfo {
              dateOfInjury
              startDateOfInjury
              __typename
            }
          }
        }
      }
      s3FileKey
      uploadedFilesSetID
      uploadedFilesSet {
        id
        uploadedFiles {
          items {
            id
            type
            provider
            key
            sourceAppointmentID
            __typename
          }
        }
      }
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    AppointmentsByGlobalInquiryDateQueryVariables,
    AppointmentsByGlobalInquiryDateQuery
  >;

export const appointmentRecordsByDoctorIDAndDateAndTime =
  /* GraphQL */ `query AppointmentRecordsByDoctorIDAndDateAndTime(
  $doctorID: ID!
  $dateTime: ModelAppointmentRecordByDoctorCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByDoctorIDAndDateAndTime(
    doctorID: $doctorID
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      time
      additionalTimeslots {
        date
        time
        locationID
      }
      inquiryDate
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        title
        titleExtension
        availabilities {
          generalAvailabilities {
            during {
              start
              end
            }
            recurrence
            dayOfWeek
            dayOfMonth
            weekOfMonth
            monthInterval
            startTime
            endTime
            flexibleTimeBefore {
              startTime
              endTime
            }
            flexibleTimeAfter {
              startTime
              endTime
            }
            locationIDs
            isAllLocations
          }
          additionalAvailabilities {
            during {
              start
              end
            }
            startTime
            endTime
            flexibleTimeBefore {
              startTime
              endTime
            }
            flexibleTimeAfter {
              startTime
              endTime
            }
            locationIDs
            isAllLocations
          }
          blackoutDates {
            during {
              start
              end
            }
            startTime
            endTime
            allDay
          }
        }
        contact {
          phone
          email
          fax
          homePhoneNumber
        }
        officePhone
        cellPhone
        clinicPhone
        collectionRate
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
      }
      locationID
      location {
        id
        name
        parkingRate
        isFrontDoorLocked
        address {
          street
          city
          state
          zip
        }
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      billingStatus
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingDate
      reschedulingNote
      panelUnavailable
      panelSpecialty
      videoCallLink
      createdAt
      medicalRecordsBriefingFileID
      historyOfInjuryGeneratedAt
      documentStatus {
        briefingPublished
        briefingCleaned
        briefingInProgress
        historyPublished
        historyCleaned
        historyInProgress
        __typename
      }
      medicalRecordsReceived
      isProd
      isDemo
      primaryPatientCaseID
      reportConfiguration {
        history
        physicalExamination
        assessment
      }
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          __typename
        }
        inquiringParty
        name
        notification_110_required
        __typename
      }
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        level
        preVisitCallScheduleLink
        inactive
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        level
        preVisitCallScheduleLink
        inactive
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        inactive
        __typename
      }
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      historyOfInjuryNotes {
        id
        content
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallCalendarLink
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        paidDate
        billedDate
        correctionDate
        billingCounter
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      patientCases {
        items {
          id
          patientCase {
            id
            patientID
            claimNumber
            injuryInfo {
              injuredBodyParts
              claimedBodyParts
              __typename
            }
            patient {
              id
              name
              dateOfBirth
              language
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                __typename
              }
            }
            workersCompInsurance {
              insuranceCarrier
              adjuster
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            qmePanelNumber
            insuranceCarrierID
            insuranceCarrier {
              id
              name
              __typename
            }
            applicantAttorney {
              name
              lawFirmName
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            defenseAttorney {
              name
              lawFirmName
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            applicantAttorneyLawFirmID
            applicantAttorneyLawFirm {
              id
              name
              __typename
            }
            defenseAttorneyLawFirmID
            defenseAttorneyLawFirm {
              id
              name
              __typename
            }
            injuryInfo {
              dateOfInjury
              startDateOfInjury
              __typename
            }
          }
        }
      }
      s3FileKey
      uploadedFilesSetID
      uploadedFilesSet {
        id
        uploadedFiles {
          items {
            id
            type
            provider
            key
            sourceAppointmentID
            __typename
          }
        }
      }
      opsChecklist {
        panel
        contact_info
        all_parties
        notice_110
        cover_letter
        record_review
        history_call
        history_of_injury
        interpreter_info
        jotform
        deu_100
        final_report
        __typename
      }
      assessment {
        markedAsDone
        __typename
      }
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    AppointmentRecordsByDoctorIDAndDateAndTimeQueryVariables,
    AppointmentRecordsByDoctorIDAndDateAndTimeQuery
  >;

// Local result type for the custom appointmentsByGlobalDateTime selection.
// The GraphQL string below selects nested objects (medicalAssistant, doctor,
// patientCases, etc.) that are stripped from the generated
// `AppointmentsByGlobalDateTimeQuery` type at maxDepth=2. Consumers that read
// past depth 2 need the wider shape declared here.
export type AppointmentsByGlobalDateTimeOptimizedItem = NonNullable<
  NonNullable<
    AppointmentsByGlobalDateTimeQuery["appointmentsByGlobalDateTime"]
  >["items"][number]
> & {
  medicalAssistant?: {
    __typename: "MedicalAssistant";
    id: string;
    name?: string | null;
    email?: string | null;
    level?: string | null;
    inactive?: boolean | null;
  } | null;
};

export type AppointmentsByGlobalDateTimeOptimizedResult = {
  appointmentsByGlobalDateTime?: {
    __typename: "ModelAppointmentRecordConnection";
    items: Array<AppointmentsByGlobalDateTimeOptimizedItem | null>;
    nextToken?: string | null;
  } | null;
};

export const appointmentsByGlobalDateTime =
  /* GraphQL */ `query AppointmentsByGlobalDateTime(
  $globalPartitionKey: String!
  $dateTime: ModelAppointmentRecordByGlobalDateTimeCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalDateTime(
    globalPartitionKey: $globalPartitionKey
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      originalAppointmentID
      supplementalAppointmentIDs
      supplementalSourceAppointmentIDs
      rescheduledFromAppointmentID
      rescheduledToAppointmentID
      date
      time
      additionalTimeslots {
        date
        time
        locationID
      }
      inquiryDate
      type
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
        title
        titleExtension
        contact {
          phone
          email
          fax
          homePhoneNumber
        }
        officePhone
        cellPhone
        clinicPhone
        collectionRate
        defaultEarlyArrivalTimeMinutes {
          workersComp
          ime
          deposition
          __typename
        }
      }
      locationID
      location {
        id
        name
        parkingRate
        isFrontDoorLocked
        address {
          street
          city
          state
          zip
        }
      }
      active
      durationMinutes
      reportDue
      reportSubmitted
      status
      reportStatus
      billingStatus
      cancellationRequestedBy
      cancellationRequestedInternally
      cancellationDate
      inquiryClosingReason
      inquiryClosingNote
      inquiryClosingDate
      noShowReason
      noShowNote
      reschedulingRequestedBy
      reschedulingRequestedInternally
      reschedulingDate
      reschedulingNote
      panelUnavailable
      panelSpecialty
      videoCallLink
      createdAt
      medicalRecordsBriefingFileID
      medicalRecordsReceived
      isProd
      primaryPatientCaseID
      reportConfiguration {
        history
        physicalExamination
        assessment
      }
      interpreter {
        certificateId
        name
        companyName
        phoneNumber
        phoneExtension
        note
        confirmed
        __typename
      }
      inquirerInfo {
        contact {
          phone
          phoneExtension
          email
          __typename
        }
        inquiringParty
        name
        notification_110_required
        __typename
      }
      scheduler {
        name
        organizationName
        contact {
          phone
          phoneExtension
          email
          __typename
        }
        __typename
      }
      medicalAssistant {
        id
        name
        email
        level
        preVisitCallScheduleLink
        inactive
        __typename
      }
      schedulingAssistant {
        id
        name
        email
        level
        preVisitCallScheduleLink
        inactive
        __typename
      }
      onSiteOp {
        id
        name
        email
        preVisitCallScheduleLink
        inactive
        __typename
      }
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      historyOfInjuryNotes {
        id
        content
        __typename
      }
      historyCallDate
      historyCallTime
      historyCallCalendarLink
      historyCallCompleted
      historyCallCompletedWithoutRecords
      historyCallCompletedOnSite
      historyCallNoShow
      billingInfo {
        diagnosisMappings {
          code
          pointer
          description
          __typename
        }
        serviceDetails {
          dateOfStart
          dateOfEnd
          place
          emergencyIndicator
          serviceType
          modifiers
          diagnosisPointers
          chargedAmount
          quantity
          amountPaid
          renderingProviderId
          __typename
        }
        totalCharge
        amountPaid
        paidDate
        billedDate
        correctionDate
        billingCounter
        __typename
      }
      caseInfo {
        confirmationEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        recordsFollowupEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        attendanceEmailStatuses {
          patient
          adjuster
          applicantAttorney
          defenseAttorney
          patientSentAt
          adjusterSentAt
          applicantAttorneySentAt
          defenseAttorneySentAt
          __typename
        }
        __typename
      }
      patientCases {
        items {
          id
          patientCase {
            id
            patientID
            claimNumber
            injuryInfo {
              injuredBodyParts
              claimedBodyParts
              __typename
            }
            patient {
              id
              name
              dateOfBirth
              language
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                __typename
              }
            }
            workersCompInsurance {
              insuranceCarrier
              adjuster
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            qmePanelNumber
            applicantAttorney {
              name
              lawFirmName
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            defenseAttorney {
              name
              lawFirmName
              contact {
                phone
                phoneExtension
                email
                address {
                  street
                  city
                  state
                  zip
                  __typename
                }
                fax
                homePhoneNumber
                __typename
              }
              __typename
            }
            applicantAttorneyLawFirmID
            applicantAttorneyLawFirm {
              id
              name
              __typename
            }
            defenseAttorneyLawFirmID
            defenseAttorneyLawFirm {
              id
              name
              __typename
            }
            injuryInfo {
              dateOfInjury
              startDateOfInjury
              __typename
            }
          }
        }
      }
      s3FileKey
      uploadedFilesSetID
      uploadedFilesSet {
        id
        uploadedFiles {
          items {
            id
            type
            provider
            key
            sourceAppointmentID
            __typename
          }
        }
      }
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    AppointmentsByGlobalDateTimeQueryVariables,
    AppointmentsByGlobalDateTimeOptimizedResult
  >;

// Minimal projection used by weekly fair-MA-assignment analytics. Only
// selects the id/date/medicalAssistant.id/patient.language needed — avoids
// overfetching the full ~370-field AppointmentRecord selection above.
export type AppointmentsByGlobalDateTimeForWeeklyFairItem = {
  __typename: "AppointmentRecord";
  id: string;
  date: string;
  medicalAssistant?: {
    __typename: "MedicalAssistant";
    id: string;
  } | null;
  patientCases?: {
    __typename: "ModelAppointmentRecordPatientCaseConnection";
    items: Array<{
      __typename: "AppointmentRecordPatientCase";
      patientCase?: {
        __typename: "PatientCase";
        id: string;
        patient?: {
          __typename: "Patient";
          id: string;
          language?: Language | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type AppointmentsByGlobalDateTimeForWeeklyFairResult = {
  appointmentsByGlobalDateTime?: {
    __typename: "ModelAppointmentRecordConnection";
    items: Array<AppointmentsByGlobalDateTimeForWeeklyFairItem | null>;
    nextToken?: string | null;
  } | null;
};

// Staffing-only projection for the ops-role impact check (MaDetailsPage):
// who holds each role on an upcoming appointment, plus what the deterministic
// re-assignment needs (type, doctor, location). Nothing else.
export type AppointmentsByGlobalDateTimeForOpsRolesItem = {
  __typename: "AppointmentRecord";
  id: string;
  date?: string | null;
  time?: string | null;
  type?: AppointmentType | null;
  status?: AppointmentStatus | null;
  active?: boolean | null;
  doctorID?: string | null;
  locationID?: string | null;
  appointmentRecordMedicalAssistantId?: string | null;
  appointmentRecordSchedulingAssistantId?: string | null;
  appointmentRecordOnSiteOpId?: string | null;
  appointmentRecordReportOpId?: string | null;
  appointmentRecordBillingOpId?: string | null;
  appointmentRecordPreVisitReviewerId?: string | null;
};

export type AppointmentsByGlobalDateTimeForOpsRolesResult = {
  appointmentsByGlobalDateTime?: {
    __typename: "ModelAppointmentRecordConnection";
    items: Array<AppointmentsByGlobalDateTimeForOpsRolesItem | null>;
    nextToken?: string | null;
  } | null;
};

export const appointmentsByGlobalDateTimeForOpsRoles =
  /* GraphQL */ `query AppointmentsByGlobalDateTimeForOpsRoles(
  $globalPartitionKey: String!
  $dateTime: ModelAppointmentRecordByGlobalDateTimeCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalDateTime(
    globalPartitionKey: $globalPartitionKey
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      date
      time
      type
      status
      active
      doctorID
      locationID
      appointmentRecordMedicalAssistantId
      appointmentRecordSchedulingAssistantId
      appointmentRecordOnSiteOpId
      appointmentRecordReportOpId
      appointmentRecordBillingOpId
      appointmentRecordPreVisitReviewerId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    AppointmentsByGlobalDateTimeQueryVariables,
    AppointmentsByGlobalDateTimeForOpsRolesResult
  >;

export const appointmentsByGlobalDateTimeForWeeklyFair =
  /* GraphQL */ `query AppointmentsByGlobalDateTime(
  $globalPartitionKey: String!
  $dateTime: ModelAppointmentRecordByGlobalDateTimeCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentsByGlobalDateTime(
    globalPartitionKey: $globalPartitionKey
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      date
      medicalAssistant {
        id
        __typename
      }
      patientCases {
        items {
          patientCase {
            id
            patient {
              id
              language
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    AppointmentsByGlobalDateTimeQueryVariables,
    AppointmentsByGlobalDateTimeForWeeklyFairResult
  >;

// Minimal query for resolving a prior appointment's persisted OpinionRecap.
// Used to surface the most recent prior opinion in the assessment tips panel —
// fetches only date + reportGenerationFileID (to pick the most recent appt that
// actually has a report) plus the recap itself, avoiding the heavy optimized query.
export const getAppointmentOpinionRecap =
  /* GraphQL */ `query GetAppointmentRecord($id: ID!) {
  getAppointmentRecord(id: $id) {
    id
    date
    reportGenerationFileID
    opinionRecap {
      id
      appointmentRecordID
      causation
      diagnosis
      mmiFutureMedicalTreatment
      impairmentRating
      apportionment
      workStatus
      sourceReportFileID
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}` as GeneratedQuery<
    GetAppointmentRecordQueryVariables,
    GetAppointmentRecordQuery
  >;

// Note: should always adjust it after code-regeneration (add address for patient's contact and workersCompInsurance)
export const getAppointmentRecordOptimized =
  /* GraphQL */ `query GetAppointmentRecord($id: ID!) {
  getAppointmentRecord(id: $id) {
    id
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    primaryPatientCaseID
    reportConfiguration {
      history
      physicalExamination
      assessment
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    date
    time
    additionalTimeslots {
      date
      time
      locationID
    }
    inquiryDate
    type
    isProd
    isDemo
    doctorID
    uploadedFilesSetID
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          s3FileKey
           __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          type
          provider
          uploadedBy
          uploadedAt
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    opsChecklist {
      panel
      contact_info
      all_parties
      notice_110
      cover_letter
      record_review
      history_call
      history_of_injury
      interpreter_info
      jotform
      deu_100
      final_report
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      title
      titleExtension
      status
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      collectionRate
      licenseNumber
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      specialties
      npi
      assessmentTreatmentOptions
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      templateFolderLink
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userDoctorId
        __typename
      }
      createdAt
      updatedAt
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      parkingRate
      isFrontDoorLocked
      address {
        street
        city
        state
        zip
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    active
    jotformSubmissions {
      id
      receivedAt
      populatedAt
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
    }
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    applicantAttorneyNotPresent
    defenseAttorneyNotPresent
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      level
      preVisitCallScheduleLink
      inactive
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userAssistantId
        __typename
      }
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      inactive
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userAssistantId
        __typename
      }
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      inactive
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userAssistantId
        __typename
      }
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      inactive
      __typename
    }
    billingOp {
      id
      name
      email
      inactive
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      inactive
      __typename
    }
    inquirerInfo {
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      inquiringParty
      name
      notification_110_required
      __typename
    }
    notes {
      items {
        id
        content
        type
        author {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        timeStamp
        appointmentrecordID
        createdAt
        updatedAt
        notesAuthorId
        __typename
      }
      nextToken
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        patientCase {
          id
          patientID
          patient {
            id
            name
            dateOfBirth
            SSN
            language
            dominantHand
            cases {
              nextToken
              __typename
            }
            contact {
              phone
              phoneExtension
              email
              fax
              homePhoneNumber
              address {
                street
                city
                state
                zip
                __typename
              }
              __typename
            }
            occupation
            height {
              feet
              inches
            }
            weightLb
            sex
            createdAt
            updatedAt
            __typename
          }
          claimNumber
          WCAB
          qmePanelNumber
          contact {
            phone
            phoneExtension
            email
            address {
              street
              city
              state
              zip
              __typename
            }
            fax
            homePhoneNumber
            __typename
          }
          injuryInfo {
            injuryType
            injuredBodyParts
            claimedBodyParts
            description
            dateOfInjury
            startDateOfInjury
            dateOfInjuryFlexible {
              value
              precision
              __typename
            }
            startDateOfInjuryFlexible {
              value
              precision
              __typename
            }
            __typename
          }
          workersCompInsurance {
            insuranceCarrier
            adjuster
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          qmePanelNumber
          applicantAttorney {
            name
            lawFirmName
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          defenseAttorney {
            name
            lawFirmName
            contact {
              phone
              phoneExtension
              email
                address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          nurseCaseManager {
            name
            organizationName
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          ccPerson {
            name
            organizationName
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          employmentAtInjury {
            employerName
            jobTitle
            contact {
              phone
              phoneExtension
              email
              fax
              homePhoneNumber
              address {
                street
                city
                state
                zip
                __typename
              }
              __typename
            }
            dateOfHire
            hoursPerWeek
            jobDuties
            dateOfTermination
            notes
            currentWorkRestrictions
            workStatus
            stillWorkingHere
            departureReason
            type
            __typename
          }
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          insuranceCarrier {
            id
            name
            defaultFaxNumberID
            addresses {
              items {
                id
                street
                city
                state
                zip
                insuranceCarrierID
                lawFirmID
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          insuranceCarrierAddress {
            id
            street
            city
            state
            zip
            insuranceCarrierID
            lawFirmID
            createdAt
            updatedAt
            __typename
          }
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          applicantAttorneyLawFirm {
            id
            name
            defaultFaxNumberID
            addresses {
              items {
                id
                street
                city
                state
                zip
                insuranceCarrierID
                lawFirmID
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          applicantAttorneyAddress {
            id
            street
            city
            state
            zip
            insuranceCarrierID
            lawFirmID
            createdAt
            updatedAt
            __typename
          }
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          defenseAttorneyLawFirm {
            id
            name
            defaultFaxNumberID
            addresses {
              items {
                id
                street
                city
                state
                zip
                insuranceCarrierID
                lawFirmID
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          defenseAttorneyAddress {
            id
            street
            city
            state
            zip
            insuranceCarrierID
            lawFirmID
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      currentWorkRestrictions
      workStatus
      stillWorkingHere
      departureReason
      type
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    referredBy
    s3FileKey
    appointmentRecordBriefingId
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    panelUnavailable
    panelSpecialty
    videoCallLink
    caseID
    contactUnavailability {
      patient {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      adjuster {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      applicantAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      defenseAttorney {
        emailUnavailable
        phoneUnavailable
        __typename
      }
      __typename
    }
    historyValidation {
      id
      appointmentRecordID
      validatedAt
      groups {
        title
        issues {
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      __typename
    }
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    assessment {
      id
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          treatments
          treatmentsExplanation
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          deferImpairmentRating
          deferImpairmentRatingReason
          deferApportionment
          deferApportionmentReason
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          apportionment
          apportionmentNotApplicable
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          evaluation {
            mmi
            mmiReason
            treatments
            treatmentsExplanation
            expectedMMITimeRange
            expectedMMITimeRangeExplanation
            deferImpairmentRating
            deferImpairmentRatingReason
            deferApportionment
            deferApportionmentReason
            discussions
            impairmentRating
            impairmentRatingNotApplicable
            apportionment
            apportionmentNotApplicable
            __typename
          }
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryFlexible {
            value
            precision
            __typename
          }
          dateOfInjuryEnd
          dateOfInjuryEndFlexible {
            value
            precision
            __typename
          }
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyPublished
      historyCleaned
      historyInProgress
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationDate
    cancellationNote
    cancellationRequestedBy
    cancellationRequestedInternally
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingDate
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    historyOfInjuryNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    historyCallDate
    historyCallTime
    historyCallCalendarLink
    historyCallCompleted
    historyCallCompletedWithoutRecords
    historyCallCompletedOnSite
    historyCallNoShow
    historyCallCalendarEventID
    appointmentRecordHistoryCallAssistantId
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      __typename
    }
    currentComplaintNotes {
      id
      content
      author {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      timeStamp
      appointmentrecordID
      createdAt
      updatedAt
      notesAuthorId
      __typename
    }
    billingInfo {
      diagnosisMappings {
        code
        pointer
        description
        __typename
      }
      serviceDetails {
        dateOfStart
        dateOfEnd
        place
        emergencyIndicator
        serviceType
        modifiers
        diagnosisPointers
        chargedAmount
        quantity
        amountPaid
        renderingProviderId
        __typename
      }
      totalCharge
      amountPaid
      paidDate
      billedDate
      correctionDate
      billingCounter
      __typename
    }
    caseInfo {
      confirmationEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      recordsFollowupEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      attendanceEmailStatuses {
        patient
        adjuster
        applicantAttorney
        defenseAttorney
        patientSentAt
        adjusterSentAt
        applicantAttorneySentAt
        defenseAttorneySentAt
        __typename
      }
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    fieldTemplateRef {
      id
      version
    }
    physicalEvalTemplateRef {
      id
      version
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
    }
    physicalExamOtherFindings {
      sectionID
      text
    }
    dataFieldValuesMappings {
      dataFieldID
      value
    }
    briefing {
      id
      generatedAt
      lastEditedAt
      lastEditedBy
    }
    difficultyLevel
    featureFlags {
      featureFlagKey
      enabled
    }
    assistantCognitoIds
    __typename
  }
}
` as GeneratedQuery<
    GetAppointmentRecordQueryVariables,
    GetAppointmentRecordQuery
  >;

export const getAppointmentRecordForDoctorOptimized =
  /* GraphQL */ `query GetAppointmentRecord($id: ID!) {
  getAppointmentRecord(id: $id) {
    id
    originalAppointmentID
    supplementalAppointmentIDs
    supplementalSourceAppointmentIDs
    rescheduledFromAppointmentID
    rescheduledToAppointmentID
    primaryPatientCaseID
    reportConfiguration {
      history
      physicalExamination
      assessment
    }
    workflowExecutions {
      items {
        executionArn
        appointmentRecordID
        type
        status
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    date
    time
    additionalTimeslots {
      date
      time
      locationID
    }
    inquiryDate
    type
    isProd
    isDemo
    doctorID
    uploadedFilesSetID
    uploadedFilesSet {
      id
      appointments {
        items {
          id
          s3FileKey
           __typename
        }
        nextToken
        __typename
      }
      uploadedFiles {
        items {
          id
          key
          type
          provider
          uploadedBy
          uploadedAt
          sourceAppointmentID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    doctor {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      title
      titleExtension
      status
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      collectionRate
      licenseNumber
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      specialties
      npi
      assessmentTreatmentOptions
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      templateFolderLink
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userDoctorId
        __typename
      }
      createdAt
      updatedAt
      doctorUserId
      __typename
    }
    locationID
    location {
      id
      name
      parkingRate
      isFrontDoorLocked
      address {
        street
        city
        state
        zip
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    active
    jotformSubmissions {
      id
      receivedAt
      populatedAt
    }
    historyTranscriptPopulations {
      uploadedFileID
      populatedAt
    }
    durationMinutes
    reportDue
    reportSubmitted
    status
    reportStatus
    paymentStatus
    billingStatus
    applicantAttorneyNotPresent
    defenseAttorneyNotPresent
    scheduler {
      name
      organizationName
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      __typename
    }
    medicalAssistant {
      id
      name
      email
      level
      preVisitCallScheduleLink
      inactive
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userAssistantId
        __typename
      }
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    schedulingAssistant {
      id
      name
      email
      preVisitCallScheduleLink
      inactive
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userAssistantId
        __typename
      }
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    onSiteOp {
      id
      name
      email
      preVisitCallScheduleLink
      inactive
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userAssistantId
        __typename
      }
      createdAt
      updatedAt
      medicalAssistantUserId
      __typename
    }
    reportOp {
      id
      name
      email
      inactive
      __typename
    }
    billingOp {
      id
      name
      email
      inactive
      __typename
    }
    preVisitReviewer {
      id
      name
      email
      inactive
      __typename
    }
    patientCases {
      items {
        id
        appointmentRecordId
        patientCaseId
        patientCase {
          id
          patientID
          patient {
            id
            name
            dateOfBirth
            SSN
            language
            dominantHand
            cases {
              nextToken
              __typename
            }
            contact {
              phone
              phoneExtension
              email
              fax
              homePhoneNumber
              address {
                street
                city
                state
                zip
                __typename
              }
              __typename
            }
            occupation
            height {
              feet
              inches
            }
            weightLb
            sex
            createdAt
            updatedAt
            __typename
          }
          claimNumber
          WCAB
          qmePanelNumber
          contact {
            phone
            phoneExtension
            email
            address {
              street
              city
              state
              zip
              __typename
            }
            fax
            homePhoneNumber
            __typename
          }
          injuryInfo {
            injuryType
            injuredBodyParts
            claimedBodyParts
            description
            dateOfInjury
            startDateOfInjury
            dateOfInjuryFlexible {
              value
              precision
              __typename
            }
            startDateOfInjuryFlexible {
              value
              precision
              __typename
            }
            __typename
          }
          workersCompInsurance {
            insuranceCarrier
            adjuster
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          qmePanelNumber
          applicantAttorney {
            name
            lawFirmName
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          defenseAttorney {
            name
            lawFirmName
            contact {
              phone
              phoneExtension
              email
                address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          nurseCaseManager {
            name
            organizationName
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          ccPerson {
            name
            organizationName
            contact {
              phone
              phoneExtension
              email
              address {
                street
                city
                state
                zip
                __typename
              }
              fax
              homePhoneNumber
              __typename
            }
            __typename
          }
          applicantAttorneyCcEmails
          defenseAttorneyCcEmails
          adjusterCcEmails
          scheduledCommsSuppressedParties
          employmentAtInjury {
            employerName
            jobTitle
            contact {
              phone
              phoneExtension
              email
              fax
              homePhoneNumber
              address {
                street
                city
                state
                zip
                __typename
              }
              __typename
            }
            dateOfHire
            hoursPerWeek
            jobDuties
            dateOfTermination
            notes
            currentWorkRestrictions
            workStatus
            stillWorkingHere
            departureReason
            type
            __typename
          }
          insuranceCarrierID
          insuranceCarrierAddressID
          insuranceCarrierFaxNumberID
          insuranceCarrierPhoneNumberID
          insuranceCarrier {
            id
            name
            addresses {
              items {
                id
                street
                city
                state
                zip
                insuranceCarrierID
                lawFirmID
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          insuranceCarrierAddress {
            id
            street
            city
            state
            zip
            insuranceCarrierID
            lawFirmID
            createdAt
            updatedAt
            __typename
          }
          applicantAttorneyLawFirmID
          applicantAttorneyAddressID
          applicantAttorneyFaxNumberID
          applicantAttorneyPhoneNumberID
          applicantAttorneyLawFirm {
            id
            name
            addresses {
              items {
                id
                street
                city
                state
                zip
                insuranceCarrierID
                lawFirmID
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          applicantAttorneyAddress {
            id
            street
            city
            state
            zip
            insuranceCarrierID
            lawFirmID
            createdAt
            updatedAt
            __typename
          }
          defenseAttorneyLawFirmID
          defenseAttorneyAddressID
          defenseAttorneyFaxNumberID
          defenseAttorneyPhoneNumberID
          defenseAttorneyLawFirm {
            id
            name
            addresses {
              items {
                id
                street
                city
                state
                zip
                insuranceCarrierID
                lawFirmID
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          defenseAttorneyAddress {
            id
            street
            city
            state
            zip
            insuranceCarrierID
            lawFirmID
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    employments {
      employerName
      jobTitle
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      dateOfHire
      dateOfHireFlexible {
        value
        precision
        __typename
      }
      hoursPerWeek
      jobDuties
      dateOfTermination
      dateOfTerminationFlexible {
        value
        precision
        __typename
      }
      notes
      currentWorkRestrictions
      workStatus
      stillWorkingHere
      departureReason
      type
      __typename
    }
    employmentGaps {
      type
      startDate {
        value
        precision
        __typename
      }
      endDate {
        value
        precision
        __typename
      }
      notes
      __typename
    }
    patientDescribedInjuries
    referredBy
    s3FileKey
    appointmentRecordBriefingId
    briefingModelVersion
    briefingGdocExportLink
    briefingGdocExportedAt
    medicalRecordsBriefingFileID
    medicalRecordsBriefingExecutionArn
    medicalRecordsTotalPagesProcessed
    reportGenerationFileID
    reportGenerationExecutionArn
    historyOfInjuryFileID
    historyOfInjuryGeneratedAt
    evaluationFileID
    assessmentFileID
    depositionPreparationFileID
    panelUnavailable
    panelSpecialty
    physicalEvalTemplateRef {
      id
      version
    }
    physicalExamValues {
      sectionID
      questionID
      side
      value
      note
      excluded
    }
    physicalExamOtherFindings {
      sectionID
      text
    }
    videoCallLink
    caseID
    appointmentRecordAssessmentId
    appointmentRecordAssessmentValidationId
    appointmentRecordMrrValidationId
    appointmentRecordHistoryMrrCrossValidationId
    appointmentRecordHistoryOfInjuryInsightsId
    appointmentRecordReviewOfMedicalRecordsInsightsId
    appointmentRecordPhysicalExamInsightsId
    appointmentRecordPastInjuryMatrixId
    assessment {
      id
      injuries {
        injuryType
        dateOfInjury
        dateOfInjuryFlexible {
          value
          precision
          __typename
        }
        dateOfInjuryEnd
        dateOfInjuryEndFlexible {
          value
          precision
          __typename
        }
        bodyParts
        causeOfInjury
        causedByWork
        causedByWorkExplanation
        __typename
      }
      discussedBodyParts
      bodyPartsNotDiscussedReason
      discussions
      diagnoses {
        diagnosis
        icdCode
        evidenceSources
        evidence
        __typename
      }
      bodyPartMMIStatus {
        discussByBodyPart
        allBodyPartsMMI {
          mmi
          mmiReason
          treatments
          treatmentsExplanation
          expectedMMITimeRange
          expectedMMITimeRangeExplanation
          deferImpairmentRating
          deferImpairmentRatingReason
          deferApportionment
          deferApportionmentReason
          discussions
          impairmentRating
          impairmentRatingNotApplicable
          apportionment
          apportionmentNotApplicable
          __typename
        }
        bodyPartMMIStatuses {
          bodyPart
          evaluation {
            mmi
            mmiReason
            treatments
            treatmentsExplanation
            expectedMMITimeRange
            expectedMMITimeRangeExplanation
            deferImpairmentRating
            deferImpairmentRatingReason
            deferApportionment
            deferApportionmentReason
            discussions
            impairmentRating
            impairmentRatingNotApplicable
            apportionment
            apportionmentNotApplicable
            __typename
          }
          __typename
        }
        __typename
      }
      workStatus
      markedAsDone
      discussDiagnosesFreeForm
      diagnosesFreeform
      discussCausationFreeForm
      causationFreeForm
      discussMMIImpairmentRatingApportionmentFreeForm
      hasPatientReachedMMIFreeForm
      discussMMIByBodyPartFreeForm
      impairmentRatingByBodyPartFreeForm
      apportionmentByBodyPartFreeForm
      impairmentRatingOtherComments
      apportionmentOtherComments
      assessmentMode
      assessmentFreeForm {
        injuries {
          injuryType
          dateOfInjury
          dateOfInjuryFlexible {
            value
            precision
            __typename
          }
          dateOfInjuryEnd
          dateOfInjuryEndFlexible {
            value
            precision
            __typename
          }
          bodyParts
          causeOfInjury
          causedByWork
          causedByWorkExplanation
          __typename
        }
        discussions
        diagnosesAndEvidence
        causation
        hasPatientReachedMMI
        discussMMIByBodyPart
        impairmentRatingByBodyPart
        apportionmentByBodyPart
        workStatus
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    documentStatus {
      evaluationPublished
      assessmentPublished
      historyPublished
      historyCleaned
      historyInProgress
      reportPublished
      briefingInProgress
      briefingPublished
      briefingCleaned
      __typename
    }
    cancellationReason
    cancellationDate
    cancellationNote
    cancellationRequestedBy
    cancellationRequestedInternally
    inquiryClosingReason
    inquiryClosingNote
    inquiryClosingDate
    noShowReason
    noShowNote
    reschedulingReason
    reschedulingOthersReason
    reschedulingDate
    reschedulingRequestedBy
    reschedulingRequestedInternally
    reschedulingNote
    interpreter {
      certificateId
      name
      companyName
      phoneNumber
      phoneExtension
      note
      confirmed
      __typename
    }
    pastInjuryMatrix {
      id
      appointmentRecordID
      preExistingConditions
      familyHistory
      injuryMatrix {
        date
        bodyPart
        status
        __typename
      }
      __typename
    }
    impairmentRatingResults {
      ts
      bodyParts
      enabledStrictRating
      enabledPainRating
      enabledAG
      enabledStrengthRating
      enabledDBE
      autoMode
      result
      resultFeedback {
        exists
        isGood
        notes
        __typename
      }
      __typename
    }
    defenseAttorneyPagesDeclaration
    applicantAttorneyPagesDeclaration
    createdAt
    updatedAt
    appointmentRecordMedicalAssistantId
    appointmentRecordSchedulingAssistantId
    appointmentRecordOnSiteOpId
    appointmentRecordReportOpId
    appointmentRecordBillingOpId
    appointmentRecordPreVisitReviewerId
    appointmentRecordHistoryOfInjuryNotesId
    appointmentRecordCurrentComplaintNotesId
    briefing {
      id
      generatedAt
      lastEditedAt
      lastEditedBy
    }
    difficultyLevel
    featureFlags {
      featureFlagKey
      enabled
    }
    __typename
  }
}
` as GeneratedQuery<
    GetAppointmentRecordQueryVariables,
    GetAppointmentRecordQuery
  >;

export const getAppointmentForAuditLogs =
  /* GraphQL */ `query GetAppointmentForAuditLogs($id: ID!) {
  getAppointmentRecord(id: $id) {
    id
    date
    time
    type
    status

    # For useAppointmentFiles hook (cover letter file IDs)
    uploadedFilesSetID
    s3FileKey

    # For Assessment audit logs (hasOne FK lives on AppointmentRecord)
    appointmentRecordAssessmentId

    # For existing note audit logs
    historyOfInjuryNotes {
      id
      __typename
    }
    currentComplaintNotes {
      id
      __typename
    }
    notes {
      items {
        id
        __typename
      }
      __typename
    }

    # For existing patient case and patient audit logs
    patientCases {
      items {
        patientCase {
          id
          patientID
          patient {
            name
          }
          __typename
        }
        __typename
      }
      __typename
    }

    __typename
  }

  # Query IntroParagraph separately using the proper index
  # Note: @hasOne relationship doesn't work because IntroParagraph has the foreign key
  introParagraphsByAppointmentRecordID(appointmentRecordID: $id, limit: 1) {
    items {
      id
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    GetAppointmentRecordQueryVariables,
    GetAppointmentRecordQuery
  >;

export const listMedicalAssistantsOptimized =
  /* GraphQL */ `query ListMedicalAssistants(
    $filter: ModelMedicalAssistantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMedicalAssistants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        level
        roles
        preVisitCallScheduleLink
        inactive
        languages
        assignmentCriteria {
          languageWeights {
            language
            weight
            doctorSpecialty
          }
        }
        user {
          id
          cognitoUserId
          avatarUrl
          firstName
          lastName
          createdAt
          updatedAt
          userDoctorId
          userAssistantId
          __typename
        }
        createdAt
        updatedAt
        medicalAssistantUserId
        __typename
      }
      nextToken
      __typename
    }
  }
  ` as GeneratedQuery<
    ListMedicalAssistantsQueryVariables,
    ListMedicalAssistantsQuery
  >;

export const getMedicalAssistantForOpsDetail =
  /* GraphQL */ `query GetMedicalAssistantForOpsDetail($id: ID!) {
    getMedicalAssistant(id: $id) {
      id
      name
      email
      phoneNumber
      joinedDate
      preVisitCallScheduleLink
      inactive
      languages
      level
      capacityPercent
      roles
      isDemo
      updatedAt
      availabilityExceptions {
        type
        during {
          start
          end
        }
        startTime
        endTime
        allDay
      }
      user {
        id
        cognitoUserId
      }
      supportedSpecialtyCategories {
        items {
          id
          specialtyCategoryId
          specialtyCategory {
            id
            name
          }
        }
      }
      __typename
    }
  }
  ` as GeneratedQuery<
    GetMedicalAssistantQueryVariables,
    GetMedicalAssistantQuery
  >;

export const listMedicalAssistantsForOpsTeam =
  /* GraphQL */ `query ListMedicalAssistantsForOpsTeam(
    $filter: ModelMedicalAssistantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMedicalAssistants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        preVisitCallScheduleLink
        inactive
        languages
        level
        roles
        phoneNumber
        isDemo
        supportedSpecialtyCategories {
          items {
            specialtyCategory {
              id
              name
            }
          }
        }
        __typename
      }
      nextToken
      __typename
    }
  }
  ` as GeneratedQuery<
    ListMedicalAssistantsQueryVariables,
    ListMedicalAssistantsQuery
  >;

export const getOpsGlobalSettingsForOps =
  /* GraphQL */ `query GetOpsGlobalSettingsForOps($key: ID!) {
    getOpsGlobalSettings(key: $key) {
      key
      inPersonEvaluationPreVisitDurationDays
      supplementalPreVisitDurationDays
      depositionPreVisitDurationDays
      opsGlobalSettingsDefaultGlobalOnsiteOpsId
      opsGlobalSettingsDefaultGlobalMAId
      opsGlobalSettingsDefaultGlobalSchedulerId
      opsGlobalSettingsDefaultGlobalReportOpsId
      opsGlobalSettingsDefaultGlobalPreVisitReviewerId
      opsGlobalSettingsDefaultGlobalBillingOpsId
      appointmentTypeMAAssignments {
        appointmentType
        maWeights {
          medicalAssistantID
          weightPercentage
        }
      }
      maAssignmentCapacitySettings {
        level1WeeklyPointBudget
        level2WeeklyPointBudget
        level3WeeklyPointBudget
        level4WeeklyPointBudget
        maxAppointmentsPerMAWeek
        maxAppointmentsPerMADay
      }
      bodyPartSpecialtiesMappings {
        bodyPart
        specialties
      }
      __typename
    }
  }
  ` as GeneratedQuery<
    GetOpsGlobalSettingsQueryVariables,
    GetOpsGlobalSettingsQuery
  >;

export const listSpecialtyCategoriesForOps =
  /* GraphQL */ `query ListSpecialtyCategoriesForOps(
    $filter: ModelSpecialtyCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpecialtyCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        specialties
        specialtyCategoryFallbackMAId
        __typename
      }
      nextToken
      __typename
    }
  }
  ` as GeneratedQuery<
    ListSpecialtyCategoriesQueryVariables,
    ListSpecialtyCategoriesQuery
  >;

export const listDoctorsOptimized = /* GraphQL */ `query ListDoctors(
  $filter: ModelDoctorFilterInput
  $limit: Int
  $nextToken: String
) {
  listDoctors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      ownerCognitoId
      firstName
      middleName
      lastName
      title
      titleExtension
      status
      ramped
      contact {
        phone
        phoneExtension
        email
        address {
          street
          city
          state
          zip
          __typename
        }
        fax
        homePhoneNumber
        __typename
      }
      officePhone
      cellPhone
      clinicPhone
      workCity
      workState
      collectionRate
      licenseNumber
      licenseRenewalDate
      qmeLicense {
        licenseNumber
        approvalDate
        renewalDate
        __typename
      }
      locations {
        items {
          id
          doctorId
          locationId
          location {
            id
            name
            address {
              street
              city
              state
              zip
              __typename
            }
            parkingRate
            isFrontDoorLocked
            doctors {
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      specialties
      npi
      bankingInfo {
        bankEntityName
        accountNumber
        routingNumber
        __typename
      }
      reportFormatPreferences {
        evaluationReport {
          sections
          assessmentSubSections
        }
        reEvaluationReport {
          sections
          assessmentSubSections
        }
        supplementalReport {
          sections
          assessmentSubSections
        }
      }
      evaluationInputPreferences {
        evaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        reEvaluationReport {
          history
          physicalExamination
          assessment
          __typename
        }
        supplementalReport {
          assessment
          __typename
        }
        __typename
      }
      preferredAssessmentMode
      briefingFields {
        items {
          id
          doctorId
          briefingFieldId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      caseSummaryFields {
        items {
          id
          doctorId
          caseSummaryFieldId
          createdAt
          updatedAt
           __typename
        }
        nextToken
        __typename
      }
      availabilitiesNote
      availabilities {
        generalAvailabilities {
          during {
            start
            end
            __typename
          }
          recurrence
          dayOfWeek
          dayOfMonth
          weekOfMonth
          monthInterval
          startTime
          endTime
          flexibleTimeBefore {
            startTime
            endTime
            __typename
          }
          flexibleTimeAfter {
            startTime
            endTime
            __typename
          }
          locationIDs
          isAllLocations
          __typename
        }
        additionalAvailabilities {
          during {
            start
            end
            __typename
          }
          startTime
          endTime
          flexibleTimeBefore {
            startTime
            endTime
            __typename
          }
          flexibleTimeAfter {
            startTime
            endTime
            __typename
          }
          locationIDs
          isAllLocations
          __typename
        }
        blackoutDates {
          during {
            start
            end
            __typename
          }
          startTime
          endTime
          allDay
          __typename
        }
        __typename
      }
      emails
      profileImages {
        type
        name
        order
        s3Prefix
        widthInInches
        heightInInches
        __typename
      }
      profileAssetS3Prefix
      calendarPreference {
        mailingList
        showPatientFullName
        showPatientAddress
        showPatientDOB
        showPortalLink
        __typename
      }
      homeOffice {
        county
        state
        __typename
      }
      user {
        id
        cognitoUserId
        avatarUrl
        firstName
        lastName
        createdAt
        updatedAt
        userDoctorId
        userAssistantId
        __typename
      }
      defaultAppointmentDurationMinutes {
        qme
        qmeReevaluation
        ime
        deposition
        __typename
      }
      defaultEarlyArrivalTimeMinutes {
        workersComp
        ime
        deposition
        __typename
      }
      templateFolderLink
      createdAt
      updatedAt
      doctorPhysicianPartnerId
      physicianPartner {
        id
        name
        email
        inactive
        __typename
      }
      doctorDefaultPrimaryOnsiteOpsId
      defaultPrimaryOnsiteOps {
        id
        name
        inactive
        __typename
      }
      doctorDefaultSecondaryOnsiteOpsId
      defaultSecondaryOnsiteOps {
        id
        name
        inactive
        __typename
      }
      doctorDefaultSchedulerId
      defaultScheduler {
        id
        name
        inactive
        __typename
      }
      doctorDefaultSupplementalReportOpsId
      defaultSupplementalReportOps {
        id
        name
        inactive
        __typename
      }
      supplementalReportOpsAssignments {
        medicalAssistantID
        weightPercentage
        __typename
      }
      doctorDefaultReportOpsId
      doctorDefaultPreVisitReviewerId
      doctorDefaultBillingOpsId
      supportingMAs {
        items {
          id
          medicalAssistantId
          doctorId
          medicalAssistant {
            id
            name
            inactive
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      doctorUserId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<ListDoctorsQueryVariables, ListDoctorsQuery>;

export const getDoctorOptimized = /* GraphQL */ `query GetDoctor($id: ID!) {
  getDoctor(id: $id) {
    id
    ownerCognitoId
    firstName
    middleName
    lastName
    title
    titleExtension
    status
    ramped
    contact {
      phone
      phoneExtension
      email
      address {
        street
        city
        state
        zip
        __typename
      }
      fax
      homePhoneNumber
      __typename
    }
    officePhone
    cellPhone
    clinicPhone
    workCity
    workState
    collectionRate
    licenseNumber
    licenseRenewalDate
    qmeLicense {
      licenseNumber
      approvalDate
      renewalDate
      __typename
    }
    locations {
      items {
        id
        doctorId
        locationId
        location {
          id
          name
          status
          address {
            street
            city
            state
            zip
            __typename
          }
          parkingRate
          isFrontDoorLocked
          doctors {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    specialties
    npi
    assessmentTreatmentOptions
    bankingInfo {
      bankEntityName
      accountNumber
      routingNumber
      __typename
    }
    reportFormatPreferences {
      evaluationReport {
        sections
        assessmentSubSections
      }
      reEvaluationReport {
        sections
        assessmentSubSections
      }
      supplementalReport {
        sections
        assessmentSubSections
      }
    }
    evaluationInputPreferences {
      evaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      reEvaluationReport {
        history
        physicalExamination
        assessment
        __typename
      }
      supplementalReport {
        assessment
        __typename
      }
      __typename
    }
    preferredAssessmentMode
    briefingFields {
      items {
        id
        doctorId
        briefingFieldId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    caseSummaryFields {
      items {
        id
        doctorId
        caseSummaryFieldId
        createdAt
        updatedAt
          __typename
      }
      nextToken
      __typename
    }
    availabilitiesNote
    availabilities {
      generalAvailabilities {
        during {
          start
          end
          __typename
        }
        recurrence
        dayOfWeek
        dayOfMonth
        weekOfMonth
        monthInterval
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      additionalAvailabilities {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        flexibleTimeBefore {
          startTime
          endTime
          __typename
        }
        flexibleTimeAfter {
          startTime
          endTime
          __typename
        }
        locationIDs
        isAllLocations
        __typename
      }
      blackoutDates {
        during {
          start
          end
          __typename
        }
        startTime
        endTime
        allDay
        __typename
      }
      __typename
    }
    emails
    profileImages {
      type
      name
      order
      s3Prefix
      widthInInches
      heightInInches
      __typename
    }
    profileAssetS3Prefix
    calendarPreference {
      mailingList
      showPatientFullName
      showPatientAddress
      showPatientDOB
      showPortalLink
      __typename
    }
    homeOffice {
      county
      state
      __typename
    }
    user {
      id
      cognitoUserId
      avatarUrl
      firstName
      lastName
      createdAt
      updatedAt
      userDoctorId
      userAssistantId
      __typename
    }
    defaultAppointmentDurationMinutes {
      qme
      qmeReevaluation
      ime
      deposition
      __typename
    }
    defaultEarlyArrivalTimeMinutes {
      workersComp
      ime
      deposition
      __typename
    }
    templateFolderLink
    createdAt
    updatedAt
    doctorPhysicianPartnerId
    physicianPartner {
      id
      name
      email
      inactive
      __typename
    }
    doctorDefaultPrimaryOnsiteOpsId
    defaultPrimaryOnsiteOps {
      id
      name
      inactive
      __typename
    }
    doctorDefaultSecondaryOnsiteOpsId
    defaultSecondaryOnsiteOps {
      id
      name
      inactive
      __typename
    }
    doctorDefaultSchedulerId
    defaultScheduler {
      id
      name
      inactive
      __typename
    }
    doctorDefaultPreVisitReviewerId
    doctorDefaultReportOpsId
    doctorDefaultBillingOpsId
    doctorDefaultSupplementalReportOpsId
    defaultSupplementalReportOps {
      id
      name
      inactive
      __typename
    }
    supplementalReportOpsAssignments {
      medicalAssistantID
      weightPercentage
      __typename
    }
    supportingMAs {
      items {
        id
        medicalAssistantId
        doctorId
        medicalAssistant {
          id
          name
          inactive
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    doctorUserId
    fieldTemplateId
    __typename
  }
}
` as GeneratedQuery<GetDoctorQueryVariables, GetDoctorQuery>;

export const listLocationsOptimized = /* GraphQL */ `query ListLocations(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      region
      address {
        street
        city
        state
        zip
        county
        __typename
      }
      abbreviation
      status
      indigoOfficePhoneNumber
      landlordContactInfo {
        name
        email
        phone
        __typename
      }
      isWaitingArea
      additionalRoomsNumber
      isParkingFree
      parkingRate
      isFrontDoorLocked
      frontDoorCode
      backDoor
      backDoorCode
      securityUnlockingProcess
      securityLockingProcess
      maleBathroomCode
      femaleBathroomCode
      wifiName
      wifiPassword
      locationDefaultOnsiteOpsId
      defaultOnsiteOps {
        id
        name
      }
      locationSecondaryOnsiteOpsId
      secondaryOnsiteOps {
        id
        name
      }
      locationInstructionsForVisitor
      additionalNote
      calendarCcEmails
      doctors {
        items {
          id
          doctorId
          locationId
          doctor {
            id
            ownerCognitoId
            firstName
            middleName
            lastName
            title
            titleExtension
            contact {
              phone
              phoneExtension
              email
              fax
              homePhoneNumber
              __typename
            }
            officePhone
            cellPhone
            clinicPhone
            collectionRate
            licenseNumber
            qmeLicense {
              licenseNumber
              approvalDate
              renewalDate
              __typename
            }
            specialties
            npi
            bankingInfo {
              bankEntityName
              accountNumber
              routingNumber
              __typename
            }
            createdAt
            updatedAt
            doctorUserId
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<ListLocationsQueryVariables, ListLocationsQuery>;

export const appointmentRecordsByUploadedFilesSetIDOptimized =
  /* GraphQL */ `query AppointmentRecordsByUploadedFilesSetID(
    $uploadedFilesSetID: ID!
    $filter: ModelAppointmentRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appointmentRecordsByUploadedFilesSetID(
      uploadedFilesSetID: $uploadedFilesSetID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        type
        status
        s3FileKey
        createdAt
      }
      nextToken
    }
  }
` as GeneratedQuery<
    AppointmentRecordsByUploadedFilesSetIDQueryVariables,
    AppointmentRecordsByUploadedFilesSetIDQuery
  >;

export const getAppointmentRecordBasic =
  /* GraphQL */ `query GetAppointmentRecordBasic($id: ID!) {
  getAppointmentRecord(id: $id) {
    id
    date
    type
    status
    isDemo
  }
}
` as GeneratedQuery<
    GetAppointmentRecordQueryVariables,
    GetAppointmentRecordQuery
  >;

export const appointmentRecordsForSchedulerAssistant = /* GraphQL */ `
query AppointmentRecordsForSchedulerAssistant(
  $doctorID: ID!
  $dateTime: ModelAppointmentRecordByDoctorCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByDoctorIDAndDateAndTime(
    doctorID: $doctorID
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      date
      time
      type
      status
      panelUnavailable
      panelSpecialty
      durationMinutes
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
      }
      patientCases {
        items {
          patientCase {
            patient {
              name
              language
            }
            injuryInfo {
              injuredBodyParts
              claimedBodyParts
            }
          }
        }
      }
      location {
        id
        name
        address {
          city
          state
        }
      }
      additionalTimeslots {
        date
        time
        locationID
      }
      locationID
    }
    nextToken
  }
}
` as GeneratedQuery<
  AppointmentRecordsByDoctorIDAndDateAndTimeQueryVariables,
  AppointmentRecordsByDoctorIDAndDateAndTimeQuery
>;

export const appointmentRecordsForSchedulerAssistantByLocation = /* GraphQL */ `
query AppointmentRecordsForSchedulerAssistantByLocation(
  $locationID: ID!
  $dateTime: ModelAppointmentRecordByLocationCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAppointmentRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  appointmentRecordsByLocationIDAndDateAndTime(
    locationID: $locationID
    dateTime: $dateTime
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      date
      time
      type
      status
      durationMinutes
      doctorID
      doctor {
        id
        ownerCognitoId
        firstName
        middleName
        lastName
      }
      patientCases {
        items {
          patientCase {
            patient {
              name
              language
            }
            injuryInfo {
              injuredBodyParts
              claimedBodyParts
            }
          }
        }
      }
      location {
        id
        name
        address {
          city
          state
        }
      }
      additionalTimeslots {
        date
        time
        locationID
      }
      locationID
    }
    nextToken
  }
}
` as GeneratedQuery<
  AppointmentRecordsByLocationIDAndDateAndTimeQueryVariables,
  AppointmentRecordsByLocationIDAndDateAndTimeQuery
>;

export const appointmentRecordsOptimized = /* GraphQL */ `
  query ListAppointmentRecordsOptimized($input: ListAppointmentsOptimizedInput!) {
    listAppointmentsOptimized(input: $input) {
      appointments {
        id
        originalAppointmentID
        supplementalAppointmentIDs
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        date
        time
        inquiryDate
        type
        doctorID
        doctorOwnerCognitoId
        doctor {
          id
          ownerCognitoId
          firstName
          middleName
          lastName
          title
          titleExtension
          contact {
            phone
            email
            fax
            homePhoneNumber
          }
          officePhone
          cellPhone
          clinicPhone
          collectionRate
        }
        locationID
        location {
          id
          name
          address {
            street
            city
            state
            zip
          }
        }
        active
        durationMinutes
        reportDue
        reportSubmitted
        status
        reportStatus
        billingStatus
        difficultyLevel
        cancellationRequestedBy
        cancellationRequestedInternally
        cancellationDate
        inquiryClosingReason
        inquiryClosingNote
        inquiryClosingDate
        noShowReason
        reschedulingRequestedBy
        reschedulingRequestedInternally
        reschedulingDate
        applicantAttorneyNotPresent
        defenseAttorneyNotPresent
        panelUnavailable
        panelSpecialty
        videoCallLink
        contactUnavailability {
          patient {
            emailUnavailable
            phoneUnavailable
            __typename
          }
          adjuster {
            emailUnavailable
            phoneUnavailable
            __typename
          }
          applicantAttorney {
            emailUnavailable
            phoneUnavailable
            __typename
          }
          defenseAttorney {
            emailUnavailable
            phoneUnavailable
            __typename
          }
          __typename
        }
        createdAt
        medicalRecordsBriefingFileID
        historyOfInjuryFileID
        historyOfInjuryGeneratedAt
        briefing {
          id
          lastEditedAt
          __typename
        }
        documentStatus {
          briefingPublished
          briefingCleaned
          historyPublished
          historyCleaned
          historyInProgress
          briefingInProgress
          __typename
        }
        isProd
        primaryPatientCaseID
        reportConfiguration {
          history
          physicalExamination
          assessment
        }
        interpreter {
          certificateId
          name
          companyName
          phoneNumber
          phoneExtension
          note
          confirmed
          __typename
        }
        inquirerInfo {
          contact {
            phone
            phoneExtension
            email
            __typename
          }
          inquiringParty
          name
          notification_110_required
          __typename
        }
        scheduler {
          name
          organizationName
          contact {
            phone
            phoneExtension
            email
            __typename
          }
          __typename
        }
        medicalAssistant {
          id
          name
          email
          level
          inactive
          __typename
        }
        schedulingAssistant {
          id
          name
          email
          level
          inactive
          __typename
        }
        onSiteOp {
          id
          name
          email
          inactive
          __typename
        }
        reportOp {
          id
          name
          __typename
        }
        appointmentRecordReportOpId
        appointmentRecordBillingOpId
        appointmentRecordPreVisitReviewerId
        historyCallDate
        historyCallTime
        historyCallCompleted
        historyCallCompletedWithoutRecords
        historyCallCompletedOnSite
        historyCallNoShow
        jotformSubmissions {
          id
          receivedAt
          populatedAt
        }
        billingInfo {
          totalCharge
          amountPaid
          paidDate
          billedDate
          correctionDate
          billingCounter
          __typename
        }
        # Keep this selection COMPLETE (all 3 CaseInfo subfields). Upcoming and
        # active-visits build their email-status mutations by spreading the
        # caseInfo they read off THIS row, and Amplify's update resolver replaces
        # nested non-model types wholesale (SET #caseInfo = :caseInfo, with no
        # read of the stored item) — so any subfield omitted here is nulled in
        # DynamoDB on the next checkbox toggle. See PR #8720.
        caseInfo {
          confirmationEmailStatuses {
            patient
            adjuster
            applicantAttorney
            defenseAttorney
            patientSentAt
            adjusterSentAt
            applicantAttorneySentAt
            defenseAttorneySentAt
            __typename
          }
          recordsFollowupEmailStatuses {
            patient
            adjuster
            applicantAttorney
            defenseAttorney
            patientSentAt
            adjusterSentAt
            applicantAttorneySentAt
            defenseAttorneySentAt
            __typename
          }
          attendanceEmailStatuses {
            patient
            adjuster
            applicantAttorney
            defenseAttorney
            patientSentAt
            adjusterSentAt
            applicantAttorneySentAt
            defenseAttorneySentAt
            __typename
          }
          __typename
        }
        patientCases {
          items {
            id
            patientCase {
              id
              patientID
              claimNumber
              injuryInfo {
                injuredBodyParts
                claimedBodyParts
                __typename
              }
              patient {
                id
                name
                language
                contact {
                  phone
                  phoneExtension
                  email
                  address {
                    street
                    city
                    state
                    zip
                    __typename
                  }
                  __typename
                }
              }
              workersCompInsurance {
                insuranceCarrier
                adjuster
                contact {
                  phone
                  phoneExtension
                  email
                  address {
                    street
                    city
                    state
                    zip
                    __typename
                  }
                  fax
                  homePhoneNumber
                  __typename
                }
                __typename
              }
              qmePanelNumber
              insuranceCarrierID
              insuranceCarrier {
                id
                name
                __typename
              }
              insuranceCarrierAddressID
              insuranceCarrierAddress {
                id
                street
                city
                state
                zip
                __typename
              }
              applicantAttorney {
                name
                lawFirmName
                contact {
                  phone
                  phoneExtension
                  email
                  address {
                    street
                    city
                    state
                    zip
                    __typename
                  }
                  fax
                  homePhoneNumber
                  __typename
                }
                __typename
              }
              defenseAttorney {
                name
                lawFirmName
                contact {
                  phone
                  phoneExtension
                  email
                  address {
                    street
                    city
                    state
                    zip
                    __typename
                  }
                  fax
                  homePhoneNumber
                  __typename
                }
                __typename
              }
              applicantAttorneyLawFirmID
              applicantAttorneyLawFirm {
                id
                name
                __typename
              }
              applicantAttorneyAddressID
              applicantAttorneyAddress {
                id
                street
                city
                state
                zip
                __typename
              }
              defenseAttorneyLawFirmID
              defenseAttorneyLawFirm {
                id
                name
                __typename
              }
              defenseAttorneyAddressID
              defenseAttorneyAddress {
                id
                street
                city
                state
                zip
                __typename
              }
              employmentAtInjury {
                employerName
                contact {
                  address {
                    street
                    city
                    state
                    zip
                    __typename
                  }
                  __typename
                }
                __typename
              }
              injuryInfo {
                dateOfInjury
                startDateOfInjury
                __typename
              }
            }
          }
        }
        s3FileKey
        uploadedFilesSetID
        assessment {
          markedAsDone
          __typename
        }
        opsChecklist {
          panel
          contact_info
          all_parties
          notice_110
          cover_letter
          record_review
          history_call
          history_of_injury
          interpreter_info
          jotform
          deu_100
          final_report
          __typename
        }
      }
      nextToken
    }
  }
` as GeneratedQuery<
  ListAppointmentsOptimizedQueryVariables,
  ListAppointmentsOptimizedQuery
>;

export const listUserAppointmentFilterPresets =
  /* GraphQL */ `query ListUserAppointmentFilterPresets(
  $filter: ModelUserAppointmentFilterPresetFilterInput
  $limit: Int
  $nextToken: String
) {
    listUserAppointmentFilterPresets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        appointmentFilterPresetId
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
    ListUserAppointmentFilterPresetsQueryVariables,
    ListUserAppointmentFilterPresetsQuery
  >;

export const getUploadedFileOptimized =
  /* GraphQL */ `query GetUploadedFile($id: ID!) {
  getUploadedFile(id: $id) {
    id
    key
    fileName
    type
    provider
    uploadedBy
    uploadedAt
    fileSizeBytes
    sourceAppointmentID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<GetUploadedFileQueryVariables, GetUploadedFileQuery>;

export const findDoctorLocationIdOptimized =
  /* GraphQL */ `query FindDoctorLocationId(
    $doctorId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDoctorLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
  doctorLocationsByDoctorId(
    doctorId: $doctorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      doctorId
      locationId
    }
  }
}
` as GeneratedQuery<
    DoctorLocationsByDoctorIdQueryVariables,
    DoctorLocationsByDoctorIdQuery
  >;

export const dataFieldsByCategoryShallow =
  /* GraphQL */ `query DataFieldsByCategoryShallow(
  $category: DataFieldCategory!
  $sortDirection: ModelSortDirection
  $filter: ModelDataFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  dataFieldsByCategory(
    category: $category
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      category
      dataType
      default
      description
      sectionID
      section {
        id
        name
        default
        createdAt
        updatedAt
        __typename
      }
      migrationKey
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    DataFieldsByCategoryQueryVariables,
    DataFieldsByCategoryQuery
  >;

export const listDataFieldSectionsShallow =
  /* GraphQL */ `query ListDataFieldSections(
  $id: ID
  $filter: ModelDataFieldSectionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDataFieldSections(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      default
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    ListDataFieldSectionsQueryVariables,
    ListDataFieldSectionsQuery
  >;

export const batchGetDataFieldsOptimized =
  /* GraphQL */ `query BatchGetDataFieldsOptimized($ids: [ID!]!) {
  batchGetDataFields(ids: $ids) {
    id
    name
    category
    dataType
    default
    description
    sectionID
    section {
      id
      name
      default
      createdAt
      updatedAt
      __typename
    }
    migrationKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<BatchGetDataFieldsQueryVariables, BatchGetDataFieldsQuery>;

export const listOnsiteOpsConfigsOptimized =
  /* GraphQL */ `query ListOnsiteOpsConfigsOptimized(
  $limit: Int
  $nextToken: String
) {
  listOnsiteOpsConfigs(
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      doctorLocationKey
      onsiteOpsConfigMedicalAssistantId
      onsiteOpsConfigSecondaryMedicalAssistantId
      assignmentEffectiveDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    ListOnsiteOpsConfigsQueryVariables,
    ListOnsiteOpsConfigsQuery
  >;

/**
 * Custom GraphQL query to fetch CoverLetterRecaps filtered by uploadedFileID.
 *
 * This query was created as a custom implementation because AWS Amplify's
 * auto-generated queries don't provide the specific filtering capabilities
 * we need for the CoverLettersSection component.
 *
 * **Why we created this custom query instead of using standard types:**
 * 1. **Missing functionality**: Standard `listCoverLetterRecaps` doesn't support uploadedFileID filtering
 * 2. **Performance optimization**: Direct filtering reduces over-fetching of data
 * 3. **Component requirements**: CoverLettersSection needs recaps for specific uploaded files only
 * 4. **Type safety**: Custom types ensure proper TypeScript validation for our specific use case
 * 5. **Real-time updates**: Works seamlessly with GraphQL subscriptions for live updates
 *
 * **Usage:**
 * ```typescript
 * const result = await client.graphql({
 *   query: listCoverLetterRecapsByUploadedFileID,
 *   variables: {
 *     uploadedFileID: "file-123",
 *     limit: 10
 *   }
 * });
 * ```
 *
/**
 * Optimized query to retrieve cover letter recaps for a specific uploaded file.
 * Based on the standard coverLetterRecapsByUploadedFileID query with sorting support.
 *
 * This query is used to:
 * - Fetch recap data for specific uploaded files
 * - Support real-time updates via subscriptions
 * - Enable efficient data loading with pagination
 *
 * @example
 * ```typescript
 * const result = await client.graphql({
 *   query: coverLetterRecapsByUploadedFileIdOptimized,
 *   variables: {
 *     uploadedFileID: "file-123",
 *     limit: 10
 *   }
 * });
 * ```
 *
 * @see CoverLetterRecapsByUploadedFileIDQueryVariables for input parameters
 * @see CoverLetterRecapsByUploadedFileIDQuery for response structure
 */
export const coverLetterRecapsByUploadedFileIdOptimized = `
  query CoverLetterRecapsByUploadedFileIDOptimized(
    $uploadedFileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCoverLetterRecapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coverLetterRecapsByUploadedFileID(
      uploadedFileID: $uploadedFileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        uploadedFileID
        recapText
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
  CoverLetterRecapsByUploadedFileIDQueryVariables,
  CoverLetterRecapsByUploadedFileIDQuery
>;

/**
 * Optimized query to retrieve intro paragraph for a specific appointment record.
 * Based on the standard introParagraphsByAppointmentRecordID query with sorting support.
 *
 * This query is used to:
 * - Fetch intro paragraph data for specific appointments
 * - Support real-time updates via subscriptions
 * - Enable efficient data loading with pagination
 *
 * @example
 * ```typescript
 * const result = await client.graphql({
 *   query: introParagraphsByAppointmentRecordIdOptimized,
 *   variables: {
 *     appointmentRecordID: "appointment-123",
 *     limit: 1
 *   }
 * });
 * ```
 *
 * @see IntroParagraphsByAppointmentRecordIDQueryVariables for input parameters
 * @see IntroParagraphsByAppointmentRecordIDQuery for response structure
 */
export const introParagraphsByAppointmentRecordIdOptimized =
  /* Line 3526 omitted */ `
  query IntroParagraphsByAppointmentRecordIDOptimized(
    $appointmentRecordID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIntroParagraphFilterInput
    $limit: Int
    $nextToken: String
  ) {
    introParagraphsByAppointmentRecordID(
      appointmentRecordID: $appointmentRecordID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        appointmentRecordID
        introParagraphText
        sourceRecaps {
          coverLetterRecapID
          uploadedFileID
          recapText
          generatedAt
          __typename
        }
        status
        errorMessage
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
    IntroParagraphsByAppointmentRecordIDQueryVariables,
    IntroParagraphsByAppointmentRecordIDQuery
  >;

// ========================================================================================
// Record Briefing Queries
// ========================================================================================

/**
 * Fetch only the record briefing metadata by appointment ID (without segment mappings)
 * Use this with segmentMappingsByBriefingIdOptimized for efficient pagination
 */
export const getRecordBriefingMetadataByAppointment =
  /* GraphQL */ `query GetRecordBriefingMetadataByAppointment(
  $appointmentId: ID!
) {
  getAppointmentRecord(id: $appointmentId) {
    id
    appointmentRecordBriefingId
    briefing {
      id
      logicalBriefingID
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
      googleDocExportLink
      googleDocExportedAt
      editingPresence
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<{ appointmentId: string }, GetAppointmentRecordQuery>;

/**
 * Fetch record briefing by appointment ID with all segment mappings and segments
 * Supports pagination for segment mappings
 * Note: For large datasets, prefer using getRecordBriefingMetadataByAppointment
 * followed by segmentMappingsByBriefingIdOptimized
 */
export const getRecordBriefingByAppointmentOptimized =
  /* GraphQL */ `query GetRecordBriefingByAppointment(
  $appointmentId: ID!
  $limit: Int
  $nextToken: String
) {
  getAppointmentRecord(id: $appointmentId) {
    id
    briefing {
      id
      logicalBriefingID
      generatedAt
      lastEditedAt
      lastEditedBy
      segmentMappings(limit: $limit, nextToken: $nextToken) {
        items {
          id
          briefingID
          logicalSegmentID
          publishedSegmentID
          draftSegmentID
          markedForDeletion
          markedForCreation
          publishedSegment {
            id
            logicalSegmentID
            title
            text
            bodyParts
            injuredBodyParts
            editedBy
            pdfFileName
            sourceTag
            segmentNumber
            sourcePdfS3Key
            startPageNumber
            endPageNumber
            recordType
            extractedDate
            doctorName
            processingModel
            classificationConfidence
            hasDate
            potentialDuplicateID
            needsReview
            status
            documentID
            videoStartTime
            videoEndTime
            createdAt
            updatedAt
            __typename
          }
          draftSegment {
            id
            logicalSegmentID
            title
            text
            bodyParts
            injuredBodyParts
            editedBy
            pdfFileName
            sourceTag
            segmentNumber
            sourcePdfS3Key
            startPageNumber
            endPageNumber
            recordType
            extractedDate
            doctorName
            processingModel
            classificationConfidence
            hasDate
            potentialDuplicateID
            needsReview
            status
            documentID
            videoStartTime
            videoEndTime
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
      }
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    { appointmentId: string; limit?: number; nextToken?: string },
    GetAppointmentRecordQuery
  >;

/**
 * Query segment mappings by briefing ID
 */
export const segmentMappingsByBriefingIdOptimized = /* GraphQL */ `
  query SegmentMappingsByBriefingId(
    $briefingID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRecordBriefingSegmentMappingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    segmentMappingsByBriefingId(
      briefingID: $briefingID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        briefingID
        logicalSegmentID
        publishedSegmentID
        draftSegmentID
        markedForDeletion
        markedForCreation
        publishedSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        draftSegment {
          id
          logicalSegmentID
          title
          text
          bodyParts
          injuredBodyParts
          editedBy
          pdfFileName
          sourceTag
          segmentNumber
          sourcePdfS3Key
          startPageNumber
          endPageNumber
          recordType
          extractedDate
          doctorName
          processingModel
          classificationConfidence
          hasDate
          potentialDuplicateID
          needsReview
          status
          documentID
          videoStartTime
          videoEndTime
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
  SegmentMappingsByBriefingIdQueryVariables,
  SegmentMappingsByBriefingIdQuery
>;

/**
 * Query all record briefing versions by logical briefing ID
 * Used for the record review history page to fetch all versions
 * Note: sortDirection not supported as byLogicalBriefingId index has no sort key
 */
export const recordBriefingsByLogicalIdWithSegments = /* GraphQL */ `
  query RecordBriefingsByLogicalIdWithSegments(
    $logicalBriefingID: ID!
    $limit: Int
    $nextToken: String
  ) {
    recordBriefingsByLogicalId(
      logicalBriefingID: $logicalBriefingID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        logicalBriefingID
        generatedAt
        lastEditedAt
        lastEditedBy
        createdAt
        updatedAt
        segmentMappings {
          items {
            id
            briefingID
            logicalSegmentID
            publishedSegmentID
            markedForDeletion
            markedForCreation
            publishedSegment {
              id
              logicalSegmentID
              title
              text
              bodyParts
              injuredBodyParts
              editedBy
              pdfFileName
              sourceTag
              segmentNumber
              sourcePdfS3Key
              startPageNumber
              endPageNumber
              recordType
              extractedDate
              doctorName
              processingModel
              classificationConfidence
              hasDate
              potentialDuplicateID
              needsReview
              status
              documentID
              videoStartTime
              videoEndTime
              createdAt
              updatedAt
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
  { logicalBriefingID: string; limit?: number; nextToken?: string },
  {
    recordBriefingsByLogicalId: { items: RecordBriefing[]; nextToken?: string };
  }
>;

export const listAuditLogsOptimized =
  /* GraphQL */ `query ListAuditLogsOptimized(
  $id: ID
  $timestamp: ModelStringKeyConditionInput
  $filter: ModelAuditLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAuditLogs(
    id: $id
    timestamp: $timestamp
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      timestamp
      tableName
      recordId
      action
      ttl
      oldImage
      newImage
      changedFields
      eventID
      eventSource
      approximateCreationDateTime
      modifiedBy
      impersonatedBy
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<ListAuditLogsQueryVariables, ListAuditLogsQuery>;

export const listInsuranceCarriersOptimized =
  /* GraphQL */ `query ListInsuranceCarriers(
  $filter: ModelInsuranceCarrierFilterInput
  $limit: Int
  $nextToken: String
) {
  listInsuranceCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      defaultEmail
      supportedDomains
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    ListInsuranceCarriersQueryVariables,
    ListInsuranceCarriersQuery
  >;

export const listInsuranceCarriersWithFaxManagementOptimized =
  /* GraphQL */ `query ListInsuranceCarriersWithFaxManagement(
  $filter: ModelInsuranceCarrierFilterInput
  $limit: Int
  $nextToken: String
) {
  listInsuranceCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      defaultEmail
      supportedDomains
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          insuranceCarrierID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          insuranceCarrierID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          insuranceCarrierID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    ListInsuranceCarriersQueryVariables,
    ListInsuranceCarriersQuery
  >;

export const getInsuranceCarrierOptimized =
  /* GraphQL */ `query GetInsuranceCarrier($id: ID!) {
  getInsuranceCarrier(id: $id) {
    id
    name
    defaultEmail
    supportedDomains
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}` as GeneratedQuery<
    GetInsuranceCarrierQueryVariables,
    GetInsuranceCarrierQuery
  >;

export const getInsuranceCarrierWithFaxManagementOptimized =
  /* GraphQL */ `query GetInsuranceCarrierWithFaxManagement($id: ID!) {
  getInsuranceCarrier(id: $id) {
    id
    name
    defaultEmail
    supportedDomains
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      insuranceCarrierID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      insuranceCarrierID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        insuranceCarrierID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}` as GeneratedQuery<
    GetInsuranceCarrierQueryVariables,
    GetInsuranceCarrierQuery
  >;

export const listLawFirmsOptimized = /* GraphQL */ `query ListLawFirms(
  $filter: ModelLawFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  listLawFirms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      defaultEmail
      supportedDomains
      type
      addresses {
        items {
          id
          street
          city
          state
          zip
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<ListLawFirmsQueryVariables, ListLawFirmsQuery>;

export const listLawFirmsWithFaxManagementOptimized =
  /* GraphQL */ `query ListLawFirmsWithFaxManagement(
  $filter: ModelLawFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  listLawFirms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      defaultEmail
      supportedDomains
      type
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<ListLawFirmsQueryVariables, ListLawFirmsQuery>;

export const getLawFirmOptimized = /* GraphQL */ `query GetLawFirm($id: ID!) {
  getLawFirm(id: $id) {
    id
    name
    defaultEmail
    supportedDomains
    type
    addresses {
      items {
        id
        street
        city
        state
        zip
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}` as GeneratedQuery<GetLawFirmQueryVariables, GetLawFirmQuery>;

export const getLawFirmWithFaxManagementOptimized =
  /* GraphQL */ `query GetLawFirmWithFaxManagement($id: ID!) {
  getLawFirm(id: $id) {
    id
    name
    defaultEmail
    supportedDomains
    type
    defaultAddressID
    defaultAddress {
      id
      street
      city
      state
      zip
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    addresses {
      items {
        id
        street
        city
        state
        zip
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultFaxNumberID
    defaultFaxNumber {
      id
      faxNumber
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    faxNumbers {
      items {
        id
        faxNumber
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    defaultPhoneNumberID
    defaultPhoneNumber {
      id
      phoneNumber
      extension
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    phoneNumbers {
      items {
        id
        phoneNumber
        extension
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}` as GeneratedQuery<GetLawFirmQueryVariables, GetLawFirmQuery>;

export const lawFirmsByTypeOptimized = /* GraphQL */ `query LawFirmsByType(
  $type: LawFirmType!
  $sortDirection: ModelSortDirection
  $filter: ModelLawFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  lawFirmsByType(
    type: $type
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      defaultEmail
      supportedDomains
      addresses {
        items {
          id
          street
          city
          state
          zip
        }
      }
    }
    nextToken
  }
}` as GeneratedQuery<LawFirmsByTypeQueryVariables, LawFirmsByTypeQuery>;

export const lawFirmsByTypeWithFaxManagementOptimized =
  /* GraphQL */ `query LawFirmsByTypeWithFaxManagement(
  $type: LawFirmType!
  $sortDirection: ModelSortDirection
  $filter: ModelLawFirmFilterInput
  $limit: Int
  $nextToken: String
) {
  lawFirmsByType(
    type: $type
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      type
      defaultEmail
      supportedDomains
      defaultAddressID
      defaultAddress {
        id
        street
        city
        state
        zip
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      addresses {
        items {
          id
          street
          city
          state
          zip
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultFaxNumberID
      defaultFaxNumber {
        id
        faxNumber
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      faxNumbers {
        items {
          id
          faxNumber
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      defaultPhoneNumberID
      defaultPhoneNumber {
        id
        phoneNumber
        extension
        lawFirmID
        createdAt
        updatedAt
        __typename
      }
      phoneNumbers {
        items {
          id
          phoneNumber
          extension
          lawFirmID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<LawFirmsByTypeQueryVariables, LawFirmsByTypeQuery>;

export const listStoredAddressesOptimized =
  /* GraphQL */ `query ListStoredAddresses(
  $filter: ModelStoredAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoredAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    ListStoredAddressesQueryVariables,
    ListStoredAddressesQuery
  >;

export const listStoredFaxNumbersOptimized =
  /* GraphQL */ `query ListStoredFaxNumbers(
  $filter: ModelStoredFaxNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoredFaxNumbers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    ListStoredFaxNumbersQueryVariables,
    ListStoredFaxNumbersQuery
  >;

export const listStoredPhoneNumbersOptimized =
  /* GraphQL */ `query ListStoredPhoneNumbers(
  $filter: ModelStoredPhoneNumberFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoredPhoneNumbers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    ListStoredPhoneNumbersQueryVariables,
    ListStoredPhoneNumbersQuery
  >;

// ========================================================================================
// Record Briefing Segment Annotation Queries
// ========================================================================================

/**
 * List all annotations for a logical briefing ID
 * Used to fetch starred state for all segments in a briefing
 */
export const listRecordBriefingSegmentAnnotations =
  /* GraphQL */ `query ListRecordBriefingSegmentAnnotations(
  $id: ID
  $logicalSegmentID: ModelStringKeyConditionInput
  $filter: ModelRecordBriefingSegmentAnnotationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRecordBriefingSegmentAnnotations(
    id: $id
    logicalSegmentID: $logicalSegmentID
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      logicalSegmentID
      isStarred
      isImportant
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    ListRecordBriefingSegmentAnnotationsQueryVariables,
    ListRecordBriefingSegmentAnnotationsQuery
  >;

export const historyValidationsByAppointmentRecordID =
  /* GraphQL */ `query HistoryValidationsByAppointmentRecordID(
  $appointmentRecordID: ID!
  $filter: ModelHistoryValidationFilterInput
  $limit: Int
  $nextToken: String
) {
  historyValidationsByAppointmentRecordID(
    appointmentRecordID: $appointmentRecordID
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      appointmentRecordID
      status
      validatedAt
      errorMessage
      groups {
        id
        title
        status
        issues {
          id
          title
          description
          patientInfoSection
          issueType
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    HistoryValidationsByAppointmentRecordIDQueryVariables,
    HistoryValidationsByAppointmentRecordIDQuery
  >;

// FieldTemplate queries for Phase 2 dual-write mode
export const getFieldTemplateOptimized = /* GraphQL */ `
  query GetFieldTemplate($id: ID!, $version: Int!) {
    getFieldTemplate(id: $id, version: $version) {
      id
      version
      templateType
      doctorId
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      createdAt
      updatedAt
      __typename
    }
  }
` as GeneratedQuery<GetFieldTemplateQueryVariables, GetFieldTemplateQuery>;

export const listFieldTemplatesByDoctorIdLatest = /* GraphQL */ `
  query FieldTemplatesByDoctorIdAndVersion(
    $doctorId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
  ) {
    fieldTemplatesByDoctorIdAndVersion(
      doctorId: $doctorId
      sortDirection: $sortDirection
      limit: $limit
    ) {
      items {
        id
        version
        templateType
        doctorId
        adlFieldSectionMappings {
          ADLFieldSectionID
          ADLFieldIDs
          __typename
        }
        medicalHistoryFieldIDs
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
` as GeneratedQuery<
  FieldTemplatesByDoctorIdAndVersionQueryVariables,
  FieldTemplatesByDoctorIdAndVersionQuery
>;

// ========================================================================================
// RecordBriefingSegmentSuggestion Queries
// ========================================================================================

/**
 * Fetch AI-generated suggestions for a record briefing by briefingID
 * Uses the byBriefingId index for efficient querying
 */
export const suggestionsByBriefingIdOptimized =
  /* GraphQL */ `query SuggestionsByBriefingId(
  $briefingID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordBriefingSegmentSuggestionFilterInput
  $limit: Int
  $nextToken: String
) {
  suggestionsByBriefingId(
    briefingID: $briefingID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      briefingID
      logicalSegmentID
      suggestionType
      reason
      reasonDetails
      textRange {
        textToDelete
        occurrenceIndex
        prefixContext
        suffixContext
      }
      status
      resolvedBy
      resolvedAt
      confidence
      relatedSegmentID
      seen
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<
    SuggestionsByBriefingIdQueryVariables,
    SuggestionsByBriefingIdQuery
  >;

export type ListUsersLiteQuery = {
  listUsers?: {
    __typename: "ModelUserConnection";
    items: Array<{
      __typename: "User";
      id: string;
      cognitoUserId: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export const listUsersLite = /* GraphQL */ `query ListUsersLite(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoUserId
      firstName
      lastName
      __typename
    }
    nextToken
    __typename
  }
}` as GeneratedQuery<ListUsersQueryVariables, ListUsersLiteQuery>;

export const appointmentRecordsByOriginalAppointmentIDOptimized =
  /* GraphQL */ `query AppointmentRecordsByOriginalAppointmentID(
    $originalAppointmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAppointmentRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appointmentRecordsByOriginalAppointmentID(
      originalAppointmentID: $originalAppointmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        type
        status
        billingStatus
        reportStatus
        s3FileKey
        uploadedFilesSetID
        originalAppointmentID
        rescheduledFromAppointmentID
        rescheduledToAppointmentID
        reschedulingRequestedBy
        reschedulingRequestedInternally
        noShowReason
        isDemo
      }
      nextToken
    }
  }
` as GeneratedQuery<
    AppointmentRecordsByOriginalAppointmentIDQueryVariables,
    AppointmentRecordsByOriginalAppointmentIDQuery
  >;

/**
 * ID-only variant of searchAppointmentsCustom.
 * Used by Historian users to avoid leaking sensitive appointment data
 * for records they may not be authorized to view in full.
 */
export const searchAppointmentsIdOnly =
  /* GraphQL */ `query SearchAppointmentsIdOnly($input: AppointmentSearchInput!) {
  searchAppointmentsCustom(input: $input) {
    items {
      id
      __typename
    }
    total
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    SearchAppointmentsCustomQueryVariables,
    SearchAppointmentsCustomQuery
  >;

// ── AppointmentNotification ──

export const portalNotificationsByRecipient = `
  query PortalNotificationsByRecipient(
    $recipientID: ID!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAppointmentNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appointmentNotificationsByRecipientAndStatus(
      recipientID: $recipientID
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        appointmentRecordID
        notificationType
        title
        body
        status
        readAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
` as GeneratedQuery<
  AppointmentNotificationsByRecipientAndStatusQueryVariables,
  AppointmentNotificationsByRecipientAndStatusQuery
>;

/** Lightweight version for Splits tab — omits text field to reduce payload for large documents */
export const documentPagesByDocumentIDAndPageNumberLight = /* GraphQL */ `
  query DocumentPagesByDocumentIDAndPageNumberLight(
    $documentID: ID!
    $pageNumber: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentPagesByDocumentIDAndPageNumber(
      documentID: $documentID
      pageNumber: $pageNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pageNumber
        imageS3Key
      }
      nextToken
    }
  }
` as GeneratedQuery<
  DocumentPagesByDocumentIDAndPageNumberQueryVariables,
  DocumentPagesByDocumentIDAndPageNumberQuery
>;

// Resolves an uploaded file to its Document id (RecordReviewTab's
// added-entry summarization). Reads only the id — the generated query
// would eagerly resolve the whole Document graph.
export const documentsByUploadedFileIDForDocumentId = /* GraphQL */ `
  query DocumentsByUploadedFileIDForDocumentId($uploadedFileID: ID!) {
    documentsByUploadedFileID(uploadedFileID: $uploadedFileID, limit: 1) {
      items {
        id
      }
    }
  }
`;

// Slim query for the Splits page (useFileDocuments / useDocumentPages). The
// generated documentsByUploadedFileID eagerly resolves the entire Document
// graph — including the `mrrValidation` Validation @hasOne, which throws once
// a doc has a linked validation (the nested resolve returns non-nullable
// nulls). The splits UI reads only these scalars off the Document; pages and
// intervals are fetched via separate queries, so none of the heavy nested
// connections are needed here.
export const documentsByUploadedFileIDForSplits = /* GraphQL */ `
  query DocumentsByUploadedFileIDForSplits($uploadedFileID: ID!) {
    documentsByUploadedFileID(uploadedFileID: $uploadedFileID, limit: 1) {
      items {
        id
        uploadedFileID
        pageCount
      }
    }
  }
`;

// Slim query for the Upload tab's Pages column. Reads every Document for the
// file (re-ingestion can leave more than one) and avoids the generated query's
// `mrrValidation` over-fetch.
export const documentsByUploadedFileIDForPageCount = /* GraphQL */ `
  query DocumentsByUploadedFileIDForPageCount($uploadedFileID: ID!) {
    documentsByUploadedFileID(uploadedFileID: $uploadedFileID) {
      items {
        id
        pageCount
      }
    }
  }
`;

// Minimal query for resolving an uploaded file to its briefing id
// (recordBriefing.fetchBriefingIdForFile). Avoids the generated query's
// `mrrValidation` over-fetch — this caller reads only `recordBriefingId`.
export const documentsByUploadedFileIDForBriefingId = /* GraphQL */ `
  query DocumentsByUploadedFileIDForBriefingId(
    $uploadedFileID: ID!
    $limit: Int
  ) {
    documentsByUploadedFileID(uploadedFileID: $uploadedFileID, limit: $limit) {
      items {
        id
        recordBriefingId
      }
    }
  }
`;

// Slim query for the sub-rosa duration UI — `videoDurationSeconds` is
// written by the video-summarization batch job after the upload is
// ingested. `createdAt` is used to pick the most recent Document when
// a UploadedFile has been re-ingested (multiple rows per file).
export const documentsByUploadedFileIDForVideoDuration = /* GraphQL */ `
  query DocumentsByUploadedFileIDForVideoDuration($uploadedFileID: ID!) {
    documentsByUploadedFileID(uploadedFileID: $uploadedFileID) {
      items {
        id
        uploadedFileID
        videoDurationSeconds
        createdAt
      }
    }
  }
`;

// V2 ingestion-progress read path. Pulls the Document plus its
// ingestionSteps connection so the RecordReviewTab can derive per-step
// status without round-tripping through the workflow-status lambda.
export const documentsByUploadedFileIDWithIngestionSteps = /* GraphQL */ `
  query DocumentsByUploadedFileIDWithIngestionSteps($uploadedFileID: ID!) {
    documentsByUploadedFileID(uploadedFileID: $uploadedFileID) {
      items {
        id
        uploadedFileID
        executionArn
        providerTag
        recordBriefingId
        createdAt
        ingestionSteps {
          items {
            id
            name
            status
            startedAt
            endedAt
            errorMessage
          }
        }
      }
    }
  }
`;

/**
 * Slim getDocument query that only returns segmentIntervals — used by the
 * Record Review tab to detect "Split changed" segments without pulling all
 * document pages, preview, and other heavy fields.
 */
export const getDocumentSegmentIntervals = /* GraphQL */ `
  query GetDocumentSegmentIntervals($id: ID!) {
    getDocument(id: $id) {
      id
      segmentIntervals {
        startPageNumber
        endPageNumber
        edited
        needsReSummary
      }
    }
  }
`;

// ── CaseRecord Dashboard ──

export interface CaseRecordDashboardAppointment {
  __typename: "AppointmentRecord";
  id: string;
  date: string;
  type?: string | null;
  status?: string | null;
  difficultyLevel?: number | null;
  createdAt: string;
  updatedAt: string;
  doctor?: {
    id: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
  } | null;
  patientCases?: {
    items: Array<{
      patientCase: {
        patient?: {
          id: string;
          name?: string | null;
          language?: string | null;
        } | null;
      };
    }>;
  } | null;
}

export interface CaseRecordDashboardItem {
  __typename: "CaseRecord";
  id: string;
  state?: CaseState | null;
  createdAt: string;
  updatedAt: string;
  appointments?: {
    items: CaseRecordDashboardAppointment[];
    nextToken?: string | null;
  } | null;
}

export interface ListCaseRecordsForDashboardQuery {
  listCaseRecords?: {
    __typename: "ModelCaseRecordConnection";
    items: CaseRecordDashboardItem[];
    nextToken?: string | null;
  } | null;
}

export const listCaseRecordsForDashboard = /* GraphQL */ `
  query ListCaseRecordsForDashboard(
    $filter: ModelCaseRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        state
        createdAt
        updatedAt
        appointments(limit: 1000) {
          items {
            id
            date
            type
            status
            difficultyLevel
            createdAt
            updatedAt
            doctor {
              id
              firstName
              middleName
              lastName
            }
            patientCases {
              items {
                patientCase {
                  patient {
                    id
                    name
                    language
                  }
                }
              }
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
` as GeneratedQuery<
  ListCaseRecordsQueryVariables,
  ListCaseRecordsForDashboardQuery
>;

// ── CaseRecord Detail (single case + nested appointments w/ assessment) ──

export interface CaseDetailPatient {
  __typename: "Patient";
  id: string;
  name?: string | null;
  dateOfBirth?: string | null;
  occupation?: string | null;
  sex?: string | null;
  language?: string | null;
  dominantHand?: string | null;
  contact?: CaseDetailContactInfo | null;
}

export interface CaseDetailContactInfo {
  __typename: "ContactInfo";
  phone?: string | null;
  email?: string | null;
}

export interface CaseDetailContactPersonInfo {
  __typename: "ContactPersonInfo";
  name?: string | null;
  organizationName?: string | null;
  contact?: CaseDetailContactInfo | null;
}

export interface CaseDetailAttorneyInfo {
  __typename: "AttorneyInfo";
  name?: string | null;
  lawFirmName?: string | null;
  contact?: CaseDetailContactInfo | null;
}

export interface CaseDetailLawFirm {
  __typename: "LawFirm";
  id: string;
  name: string;
}

export interface CaseDetailWorkersCompInsuranceInfo {
  __typename: "WorkersCompInsuranceInfo";
  insuranceCarrier?: string | null;
  adjuster?: string | null;
  contact?: CaseDetailContactInfo | null;
}

export interface CaseDetailInsuranceCarrier {
  __typename: "InsuranceCarrier";
  id: string;
  name: string;
}

export interface CaseDetailBillingInfo {
  __typename: "BillingInfo";
  totalCharge?: number | null;
  billedDate?: string | null;
}

export interface CaseDetailPatientCase {
  __typename: "PatientCase";
  id: string;
  claimNumber: string;
  qmePanelNumber?: string | null;
  patient?: CaseDetailPatient | null;
  injuryInfo?: CaseDetailInjuryInfo | null;
  applicantAttorney?: CaseDetailAttorneyInfo | null;
  applicantAttorneyLawFirm?: CaseDetailLawFirm | null;
  defenseAttorney?: CaseDetailAttorneyInfo | null;
  defenseAttorneyLawFirm?: CaseDetailLawFirm | null;
  nurseCaseManager?: CaseDetailContactPersonInfo | null;
  workersCompInsurance?: CaseDetailWorkersCompInsuranceInfo | null;
  insuranceCarrier?: CaseDetailInsuranceCarrier | null;
}

export interface CaseDetailAssessmentInjury {
  __typename: "AssessmentInjury";
  dateOfInjury?: string | null;
  bodyParts?: Array<string | null> | null;
  causeOfInjury?: string | null;
}

export interface CaseDetailAssessmentDiagnosis {
  __typename: "AssessmentDiagnosis";
  diagnosis?: string | null;
  icdCode?: string | null;
}

export interface CaseDetailAssessment {
  __typename: "Assessment";
  id: string;
  injuries?: Array<CaseDetailAssessmentInjury | null> | null;
  diagnoses?: Array<CaseDetailAssessmentDiagnosis | null> | null;
  diagnosesFreeform?: string | null;
  causationFreeForm?: string | null;
  apportionmentByBodyPartFreeForm?: string | null;
  hasPatientReachedMMIFreeForm?: string | null;
  discussMMIByBodyPartFreeForm?: string | null;
  impairmentRatingByBodyPartFreeForm?: string | null;
  workStatus?: string | null;
}

export interface CaseDetailImpairmentRatingResult {
  __typename: "ImpairmentRatingResult";
  bodyParts?: Array<string | null> | null;
  result?: string | null;
}

export interface CaseDetailInjuryInfo {
  __typename: "InjuryInfo";
  injuryType?: string | null;
  injuredBodyParts?: Array<string | null> | null;
  claimedBodyParts?: Array<string | null> | null;
  description?: string | null;
  dateOfInjury?: string | null;
  startDateOfInjury?: string | null;
}

export interface CaseDetailAppointment {
  __typename: "AppointmentRecord";
  id: string;
  date: string;
  time?: string | null;
  durationMinutes?: number | null;
  type?: AppointmentType | null;
  status?: AppointmentStatus | null;
  reportStatus?: ReportStatus | null;
  billingStatus?: BillingStatus | null;
  noShowReason?: NoShowReason | null;
  reschedulingRequestedBy?: ParticipantType | null;
  reschedulingRequestedInternally?: boolean | null;
  primaryPatientCaseID?: string | null;
  createdAt: string;
  updatedAt: string;
  doctor?: {
    id: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
  } | null;
  scheduler?: CaseDetailContactPersonInfo | null;
  billingInfo?: CaseDetailBillingInfo | null;
  patientDescribedInjuries?: Array<string | null> | null;
  patientCases?: {
    items: Array<{
      patientCase: CaseDetailPatientCase;
    }>;
  } | null;
  impairmentRatingResults?: Array<CaseDetailImpairmentRatingResult | null> | null;
  assessment?: CaseDetailAssessment | null;
  fieldTemplateRef?: { id: string; version: number } | null;
  physicalEvalTemplateRef?: { id: string; version: number } | null;
  physicalExamValues?: Array<{
    sectionID: string;
    questionID: string;
    side?: PhysicalExamSide | null;
    value?: string | null;
    note?: string | null;
    excluded?: boolean | null;
  } | null> | null;
  physicalExamOtherFindings?: Array<{
    sectionID: string;
    text?: string | null;
  } | null> | null;
  dataFieldValuesMappings?: Array<{
    dataFieldID: string;
    value?: string | null;
  } | null> | null;
}

export interface CaseDetailRecord {
  __typename: "CaseRecord";
  id: string;
  state?: CaseState | null;
  createdAt: string;
  updatedAt: string;
  appointments?: {
    items: CaseDetailAppointment[];
    nextToken?: string | null;
  } | null;
}

export interface GetCaseRecordWithAppointmentsQuery {
  getCaseRecord?: CaseDetailRecord | null;
}

/**
 * Fetch a single CaseRecord together with its appointments for the detail
 * page. Mirrors the nested-connection shape of `listCaseRecordsForDashboard`
 * but expands each appointment to include `assessment`, `impairmentRatingResults`
 * and the claimant's `Patient` so the Overview tab can derive the claimant
 * profile and the case timeline with zero additional round trips.
 */
export const getCaseRecordWithAppointments = /* GraphQL */ `
  query GetCaseRecordWithAppointments($id: ID!) {
    getCaseRecord(id: $id) {
      id
      state
      createdAt
      updatedAt
      appointments(limit: 1000) {
        items {
          id
          date
          time
          durationMinutes
          type
          status
          reportStatus
          billingStatus
          noShowReason
          reschedulingRequestedBy
          reschedulingRequestedInternally
          primaryPatientCaseID
          createdAt
          updatedAt
          doctor {
            id
            firstName
            middleName
            lastName
          }
          scheduler {
            name
            organizationName
            contact {
              phone
              email
            }
          }
          billingInfo {
            totalCharge
            billedDate
          }
          patientDescribedInjuries
          patientCases {
            items {
              patientCase {
                id
                claimNumber
                qmePanelNumber
                patient {
                  id
                  name
                  dateOfBirth
                  occupation
                  sex
                  language
                  dominantHand
                  contact {
                    phone
                    email
                  }
                }
                injuryInfo {
                  injuryType
                  injuredBodyParts
                  claimedBodyParts
                  description
                  dateOfInjury
                  startDateOfInjury
                }
                applicantAttorney {
                  name
                  lawFirmName
                  contact {
                    phone
                    email
                  }
                }
                applicantAttorneyLawFirm {
                  id
                  name
                }
                defenseAttorney {
                  name
                  lawFirmName
                  contact {
                    phone
                    email
                  }
                }
                defenseAttorneyLawFirm {
                  id
                  name
                }
                nurseCaseManager {
                  name
                  organizationName
                  contact {
                    phone
                    email
                  }
                }
                workersCompInsurance {
                  insuranceCarrier
                  adjuster
                  contact {
                    phone
                    email
                  }
                }
                insuranceCarrier {
                  id
                  name
                }
              }
            }
          }
          impairmentRatingResults {
            bodyParts
            result
          }
          assessment {
            id
            injuries {
              dateOfInjury
              bodyParts
              causeOfInjury
            }
            diagnoses {
              diagnosis
              icdCode
            }
            diagnosesFreeform
            causationFreeForm
            apportionmentByBodyPartFreeForm
            hasPatientReachedMMIFreeForm
            discussMMIByBodyPartFreeForm
            impairmentRatingByBodyPartFreeForm
            workStatus
          }
          fieldTemplateRef {
            id
            version
          }
          dataFieldValuesMappings {
            dataFieldID
            value
          }
        }
        nextToken
      }
    }
  }
` as GeneratedQuery<
  GetCaseRecordQueryVariables,
  GetCaseRecordWithAppointmentsQuery
>;

// ============================================================================
// Queries with selections exceeding maxDepth=2 in the generated TS types.
// Each declares a local *Result type and types the GraphQL string with
// GeneratedQuery<Variables, Result>.
// ============================================================================

// --- audioByUploadedFileID: needs items[].transcriptPreview.{bucket,key} ---

type AudioByUploadedFileIDWithTranscriptPreviewResult = {
  audioByUploadedFileID?: {
    __typename: "ModelAudioConnection";
    items: Array<{
      __typename: "Audio";
      id: string;
      uploadedFileID: string;
      transcriptPreview?: {
        __typename: "S3Blob";
        bucket: string;
        key: string;
      } | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export const audioByUploadedFileIDWithTranscriptPreview =
  /* GraphQL */ `query AudioByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAudioFilterInput
  $limit: Int
  $nextToken: String
) {
  audioByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      transcriptPreview {
        bucket
        key
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    AudioByUploadedFileIDQueryVariables,
    AudioByUploadedFileIDWithTranscriptPreviewResult
  >;

// --- documentsByUploadedFileID: needs items[].preview.{bucket,key} + scalar fields for debug page ---

export type DocumentWithPreview = {
  __typename: "Document";
  id: string;
  uploadedFileID: string;
  pageCount: number;
  executionArn: string;
  segmentSplits?: Array<number | null> | null;
  createdAt: string;
  updatedAt: string;
  preview?: {
    __typename: "S3Blob";
    bucket: string;
    key: string;
  } | null;
};

type DocumentsByUploadedFileIDWithPreviewResult = {
  documentsByUploadedFileID?: {
    __typename: "ModelDocumentConnection";
    items: Array<DocumentWithPreview | null>;
    nextToken?: string | null;
  } | null;
};

export const documentsByUploadedFileIDWithPreview =
  /* GraphQL */ `query DocumentsByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  documentsByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      pageCount
      executionArn
      segmentSplits
      createdAt
      updatedAt
      preview {
        bucket
        key
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    DocumentsByUploadedFileIDQueryVariables,
    DocumentsByUploadedFileIDWithPreviewResult
  >;

// --- documentsByUploadedFileID for the debug page: needs pages.items[] too ---

export type DocumentForDebug = DocumentWithPreview & {
  recordBriefingId?: string | null;
  pages?: {
    __typename: "ModelDocumentPageConnection";
    items: Array<{
      __typename: "DocumentPage";
      id: string;
      pageNumber: number;
      text?: string | null;
      imageS3Key?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

type DocumentsByUploadedFileIDForDebugResult = {
  documentsByUploadedFileID?: {
    __typename: "ModelDocumentConnection";
    items: Array<DocumentForDebug | null>;
    nextToken?: string | null;
  } | null;
};

export const documentsByUploadedFileIDForDebug =
  /* GraphQL */ `query DocumentsByUploadedFileID(
  $uploadedFileID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  documentsByUploadedFileID(
    uploadedFileID: $uploadedFileID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      uploadedFileID
      pageCount
      executionArn
      segmentSplits
      recordBriefingId
      createdAt
      updatedAt
      preview {
        bucket
        key
        __typename
      }
      pages {
        items {
          id
          pageNumber
          text
          imageS3Key
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    DocumentsByUploadedFileIDQueryVariables,
    DocumentsByUploadedFileIDForDebugResult
  >;

// --- chatbotMessagesByConversationId: needs items[].attachments[] + dataBlocks ---

export type ChatbotMessagesByConversationIdWithAttachmentsResult = {
  chatbotMessagesByConversationId?: {
    __typename: "ModelChatbotMessageConnection";
    items: Array<{
      __typename: "ChatbotMessage";
      userId: string;
      conversationIdTimestamp: string;
      messageId: string;
      conversationId: string;
      role: ChatbotMessageRole;
      content: string;
      createdAt: string;
      // AWSJSON: typed data blocks for re-rendering entity components.
      // Null on every message written before the field existed, and on any
      // reply that carried no typed block.
      dataBlocks?: string | null;
      userPaused?: boolean | null;
      // Next user message Indy suggested; null when it offered none.
      suggestedUserPrompt?: string | null;
      attachments?: Array<{
        __typename: "ChatbotAttachment";
        filename: string;
        contentType: string;
        sizeBytes: number;
        s3Bucket?: string | null;
        s3Key?: string | null;
        source?: string | null;
      } | null> | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export const chatbotMessagesByConversationIdWithAttachments =
  /* GraphQL */ `query ChatbotMessagesByConversationId(
  $conversationId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChatbotMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  chatbotMessagesByConversationId(
    conversationId: $conversationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      userId
      conversationIdTimestamp
      messageId
      conversationId
      role
      content
      createdAt
      dataBlocks
      userPaused
      suggestedUserPrompt
      attachments {
        filename
        contentType
        sizeBytes
        s3Bucket
        s3Key
        source
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    ChatbotMessagesByConversationIdQueryVariables,
    ChatbotMessagesByConversationIdWithAttachmentsResult
  >;

// --- promptExecutionsByPromptId: needs items[].{input,output,attachments[]} ---

export type PromptExecutionItemWithBlobs = {
  __typename: "PromptExecution";
  id: string;
  promptId: string;
  executedAt: string;
  appointmentID?: string | null;
  entityType?: string | null;
  entityId?: string | null;
  promptHash: string;
  apiHash?: string | null;
  modelName: string;
  modelConfig?: string | null;
  correlationID?: string | null;
  createdAt: string;
  updatedAt: string;
  input: { __typename: "S3Blob"; bucket: string; key: string };
  output: { __typename: "S3Blob"; bucket: string; key: string };
  toolCalls?: { __typename: "S3Blob"; bucket: string; key: string } | null;
  reasoningSummary?: string | null;
  attachments?: Array<{
    __typename: "PromptExecutionAttachment";
    blob: { __typename: "S3Blob"; bucket: string; key: string };
    caption?: string | null;
  } | null> | null;
};

type PromptExecutionsByPromptIdWithBlobsResult = {
  promptExecutionsByPromptId?: {
    __typename: "ModelPromptExecutionConnection";
    items: Array<PromptExecutionItemWithBlobs | null>;
    nextToken?: string | null;
  } | null;
};

export const promptExecutionsByPromptIdWithBlobs =
  /* GraphQL */ `query PromptExecutionsByPromptId(
  $promptId: String!
  $executedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromptExecutionFilterInput
  $limit: Int
  $nextToken: String
) {
  promptExecutionsByPromptId(
    promptId: $promptId
    executedAt: $executedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      executedAt
      appointmentID
      entityType
      entityId
      promptHash
      apiHash
      modelName
      modelConfig
      correlationID
      createdAt
      updatedAt
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      reasoningSummary
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    PromptExecutionsByPromptIdQueryVariables,
    PromptExecutionsByPromptIdWithBlobsResult
  >;

// --- offlineEvalCasesByPromptIdAndApiHash: needs items[].{input,output,attachments[]} ---

export type OfflineEvalCaseItemWithBlobs = {
  __typename: "PromptOfflineEvalCase";
  id: string;
  promptId: string;
  sourcePromptExecutionId?: string | null;
  apiHash: string;
  description?: string | null;
  verified?: boolean | null;
  tags?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  input: { __typename: "S3Blob"; bucket: string; key: string };
  output: { __typename: "S3Blob"; bucket: string; key: string };
  toolCalls?: { __typename: "S3Blob"; bucket: string; key: string } | null;
  attachments?: Array<{
    __typename: "PromptExecutionAttachment";
    blob: { __typename: "S3Blob"; bucket: string; key: string };
    caption?: string | null;
  } | null> | null;
};

type OfflineEvalCasesByPromptIdAndApiHashWithBlobsResult = {
  offlineEvalCasesByPromptIdAndApiHash?: {
    __typename: "ModelPromptOfflineEvalCaseConnection";
    items: Array<OfflineEvalCaseItemWithBlobs | null>;
    nextToken?: string | null;
  } | null;
};

export const offlineEvalCasesByPromptIdAndApiHashWithBlobs =
  /* GraphQL */ `query OfflineEvalCasesByPromptIdAndApiHash(
  $promptId: String!
  $apiHash: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromptOfflineEvalCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  offlineEvalCasesByPromptIdAndApiHash(
    promptId: $promptId
    apiHash: $apiHash
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promptId
      sourcePromptExecutionId
      apiHash
      description
      verified
      tags
      createdAt
      updatedAt
      input {
        bucket
        key
        __typename
      }
      output {
        bucket
        key
        __typename
      }
      toolCalls {
        bucket
        key
        __typename
      }
      attachments {
        blob {
          bucket
          key
          __typename
        }
        caption
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    OfflineEvalCasesByPromptIdAndApiHashQueryVariables,
    OfflineEvalCasesByPromptIdAndApiHashWithBlobsResult
  >;

// --- getReviewOfMedicalRecordsInsights: needs treatments.{discrete,recurring}.* ---

type GetReviewOfMedicalRecordsInsightsWithTreatmentsResult = {
  getReviewOfMedicalRecordsInsights?: {
    __typename: "ReviewOfMedicalRecordsInsights";
    id: string;
    appointmentRecordID: string;
    currentWorkRestrictionsFromMedicalRecords?: string | null;
    latestDiagnosis?: Array<BodyPartDiagnosis | null> | null;
    diagnosticStudies?: Array<DiagnosticStudy | null> | null;
    treatments?: Array<{
      __typename: "TreatmentWrapper";
      discreteTreatment?: DiscreteTreatment | null;
      recurringTreatment?: RecurringTreatment | null;
    } | null> | null;
    previousReports?: Array<PreviousReport | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export const getReviewOfMedicalRecordsInsightsWithTreatments =
  /* GraphQL */ `query GetReviewOfMedicalRecordsInsights($id: ID!) {
  getReviewOfMedicalRecordsInsights(id: $id) {
    id
    appointmentRecordID
    currentWorkRestrictionsFromMedicalRecords
    latestDiagnosis {
      bodyPart
      date
      descriptions
      __typename
    }
    diagnosticStudies {
      date
      typeOfStudy
      bodyPart
      impression
      source
      __typename
    }
    treatments {
      discreteTreatment {
        date
        treatmentType
        bodyPart
        description
        __typename
      }
      recurringTreatment {
        startDate
        endDate
        treatmentType
        bodyPart
        description
        frequency
        __typename
      }
      __typename
    }
    previousReports {
      date
      reportType
      reportContent
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
    GetReviewOfMedicalRecordsInsightsQueryVariables,
    GetReviewOfMedicalRecordsInsightsWithTreatmentsResult
  >;

// The auto-generated `workflowAuditEntriesByWorkflowAuditID` omits
// `attachments` on each entry. The debug timeline needs them so it can
// hydrate oversize-payload S3 blobs on demand.
export type WorkflowAuditEntryWithAttachments = NonNullable<
  NonNullable<
    WorkflowAuditEntriesByWorkflowAuditIDQuery["workflowAuditEntriesByWorkflowAuditID"]
  >["items"][number]
> & {
  attachments?: Array<{
    __typename: "S3Blob";
    bucket: string;
    key: string;
  } | null> | null;
};

type WorkflowAuditEntriesByWorkflowAuditIDWithAttachmentsResult = {
  workflowAuditEntriesByWorkflowAuditID?: {
    __typename: "ModelWorkflowAuditEntryConnection";
    items: Array<WorkflowAuditEntryWithAttachments | null>;
    nextToken?: string | null;
  } | null;
};

export const workflowAuditEntriesByWorkflowAuditIDWithAttachments =
  /* GraphQL */ `query WorkflowAuditEntriesByWorkflowAuditID(
  $workflowAuditID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWorkflowAuditEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  workflowAuditEntriesByWorkflowAuditID(
    workflowAuditID: $workflowAuditID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      workflowAuditID
      message
      actorType
      actorID
      entryType
      attachments {
        bucket
        key
        __typename
      }
      relatedActionIDs
      payload
      correlationID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    WorkflowAuditEntriesByWorkflowAuditIDQueryVariables,
    WorkflowAuditEntriesByWorkflowAuditIDWithAttachmentsResult
  >;

/**
 * List a doctor's latest PhysicalEvalTemplate versions across all specialty
 * categories, with the FULL nested tree (exams → sections → config + questions).
 *
 * The Amplify-generated `physicalEvalTemplatesByDoctorIdAndVersion` selection set
 * is shallow (stops at `sections { sectionID name fieldType }` — no config/questions),
 * so the configurator needs this deeper custom query. Filter to
 * `latestMarker = "LATEST"` and sort version DESC to get one row per template id
 * (the current version of each specialty-category template).
 */

/**
 * Result type for the deep query below. The auto-generated
 * `PhysicalEvalTemplatesByDoctorIdAndVersionQuery` models only the SHALLOW
 * selection set (no `config`/`questions` on sections), so reusing it would let
 * the compiler silently accept a mismatched shape. Since this query selects the
 * full model shape, type `items` as the full `PhysicalEvalTemplate` — mirroring
 * the `*WithAttachmentsResult` precedents in this file.
 */
export type PhysicalEvalTemplatesByDoctorIdLatestFullResult = {
  physicalEvalTemplatesByDoctorIdAndVersion?: {
    __typename: "ModelPhysicalEvalTemplateConnection";
    items: Array<PhysicalEvalTemplate | null>;
    nextToken?: string | null;
  } | null;
};

export const physicalEvalTemplatesByDoctorIdLatestFull =
  /* GraphQL */ `query PhysicalEvalTemplatesByDoctorIdLatestFull(
  $doctorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPhysicalEvalTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  physicalEvalTemplatesByDoctorIdAndVersion(
    doctorId: $doctorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      version
      templateType
      specialtyCategoryId
      doctorId
      latestMarker
      exams {
        examID
        name
        bodyParts
        instructions
        sections {
          sectionID
          name
          fieldType
          config {
            minValue
            maxValue
            increment
            allowPlusMinus
            allowPlus
            unit
            freeformInputCount
            laterality
            hasNote
            hasDefault
            hasOtherFindings
            renderStyle
            __typename
          }
          questions {
            questionID
            label
            defaultValue
            defaultValueLeft
            defaultValueRight
            phrasing
            positiveText
            negativeText
            __typename
          }
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      changeDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    PhysicalEvalTemplatesByDoctorIdAndVersionQueryVariables,
    PhysicalEvalTemplatesByDoctorIdLatestFullResult
  >;

/**
 * Existence probe on the byWorkflowType GSI — selects only the audit `id`.
 * The generated query also pulls every entry (payloads included), which is
 * wasted bytes when the caller only needs to know whether a run exists.
 */
export const workflowAuditIdsByWorkflowTypeAndEntity =
  /* GraphQL */ `query WorkflowAuditIdsByWorkflowTypeAndEntity(
  $workflowType: String!
  $entityTypeEntityID: ModelWorkflowAuditByWorkflowTypeCompositeKeyConditionInput
  $limit: Int
) {
  workflowAuditsByWorkflowTypeAndEntityTypeAndEntityID(
    workflowType: $workflowType
    entityTypeEntityID: $entityTypeEntityID
    limit: $limit
  ) {
    items {
      id
    }
  }
}
` as GeneratedQuery<
    WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQueryVariables,
    WorkflowAuditsByWorkflowTypeAndEntityTypeAndEntityIDQuery
  >;
